(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.a8.Q === region.bo.Q)
	{
		return 'on line ' + region.a8.Q;
	}
	return 'on lines ' + region.a8.Q + ' through ' + region.bo.Q;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.c6,
		impl.dY,
		impl.dK,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		v: func(record.v),
		a9: record.a9,
		a_: record.a_
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.v;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.a9;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.a_) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.c6,
		impl.dY,
		impl.dK,
		function(sendToApp, initialModel) {
			var view = impl.d0;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.c6,
		impl.dY,
		impl.dK,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.a1 && impl.a1(sendToApp)
			var view = impl.d0;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.bf);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.dO) && (_VirtualDom_doc.title = title = doc.dO);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.dk;
	var onUrlRequest = impl.dl;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		a1: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.bW === next.bW
							&& curr.P === next.P
							&& curr.bN.a === next.bN.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		c6: function(flags)
		{
			return A3(impl.c6, flags, _Browser_getUrl(), key);
		},
		d0: impl.d0,
		dY: impl.dY,
		dK: impl.dK
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { c_: 'hidden', ct: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { c_: 'mozHidden', ct: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { c_: 'msHidden', ct: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { c_: 'webkitHidden', ct: 'webkitvisibilitychange' }
		: { c_: 'hidden', ct: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		b1: _Browser_getScene(),
		cd: {
			ce: _Browser_window.pageXOffset,
			cf: _Browser_window.pageYOffset,
			ax: _Browser_doc.documentElement.clientWidth,
			bv: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		ax: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		bv: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			b1: {
				ax: node.scrollWidth,
				bv: node.scrollHeight
			},
			cd: {
				ce: node.scrollLeft,
				cf: node.scrollTop,
				ax: node.clientWidth,
				bv: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			b1: _Browser_getScene(),
			cd: {
				ce: x,
				cf: y,
				ax: _Browser_doc.documentElement.clientWidth,
				bv: _Browser_doc.documentElement.clientHeight
			},
			cP: {
				ce: x + rect.left,
				cf: y + rect.top,
				ax: rect.width,
				bv: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.cS.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.cS.b, xhr)); });
		$elm$core$Maybe$isJust(request.dU) && _Http_track(router, xhr, request.dU.a);

		try {
			xhr.open(request.de, request.dZ, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.dZ));
		}

		_Http_configureRequest(xhr, request);

		request.bf.a && xhr.setRequestHeader('Content-Type', request.bf.a);
		xhr.send(request.bf.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.bu; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.F.a || 0;
	xhr.responseType = request.cS.d;
	xhr.withCredentials = request.cl;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		dZ: xhr.responseURL,
		b7: xhr.status,
		dH: xhr.statusText,
		bu: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			dA: event.loaded,
			dC: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			du: event.loaded,
			dC: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}

function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.d) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.e),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.e);
		} else {
			var treeLen = builder.d * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.f) : builder.f;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.d);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.e) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.e);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{f: nodeList, d: (len / $elm$core$Array$branchFactor) | 0, e: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {bs: fragment, P: host, bL: path, bN: port_, bW: protocol, bX: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$element = _Browser_element;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $elm$json$Json$Decode$index = _Json_decodeIndex;
var $author$project$Carwow$StockDealCard$DealFetched = function (a) {
	return {$: 1, a: a};
};
var $author$project$Carwow$StockDealCard$NotVisible = {$: 0};
var $author$project$Carwow$StockDealCard$Data$Deal = F3(
	function (pricing, vehicle, supplier) {
		return {dq: pricing, dL: supplier, d$: vehicle};
	});
var $author$project$Carwow$StockDealCard$Data$CashPricing = function (a) {
	return {$: 0, a: a};
};
var $author$project$Carwow$StockDealCard$Data$PriceOnApplication = {$: 1};
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $author$project$ApiSchemas$attr = function (name) {
	return $elm$json$Json$Decode$at(
		_List_fromArray(
			['attributes', name]));
};
var $author$project$ApiSchemas$Deal$Price = F3(
	function (value, currency, timescale) {
		return {cA: currency, dN: timescale, d_: value};
	});
var $author$project$ApiSchemas$Currency$EUR = {$: 1};
var $author$project$ApiSchemas$Currency$GBP = {$: 0};
var $author$project$ApiSchemas$Currency$Unknown = function (a) {
	return {$: 2, a: a};
};
var $author$project$ApiSchemas$Currency$parse = function (value) {
	switch (value) {
		case 'GBP':
			return $author$project$ApiSchemas$Currency$GBP;
		case 'EUR':
			return $author$project$ApiSchemas$Currency$EUR;
		default:
			var unknown = value;
			return $author$project$ApiSchemas$Currency$Unknown(unknown);
	}
};
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$ApiSchemas$Currency$decoder = A2($elm$json$Json$Decode$map, $author$project$ApiSchemas$Currency$parse, $elm$json$Json$Decode$string);
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$ApiSchemas$Deal$DAY = {$: 0};
var $author$project$ApiSchemas$Deal$FOREVER = {$: 4};
var $author$project$ApiSchemas$Deal$MONTH = {$: 2};
var $author$project$ApiSchemas$Deal$UnknownTimescale = function (a) {
	return {$: 5, a: a};
};
var $author$project$ApiSchemas$Deal$WEEK = {$: 1};
var $author$project$ApiSchemas$Deal$YEAR = {$: 3};
var $author$project$ApiSchemas$Deal$parseTimescale = function (value) {
	switch (value) {
		case 'DAY':
			return $author$project$ApiSchemas$Deal$DAY;
		case 'WEEK':
			return $author$project$ApiSchemas$Deal$WEEK;
		case 'MONTH':
			return $author$project$ApiSchemas$Deal$MONTH;
		case 'YEAR':
			return $author$project$ApiSchemas$Deal$YEAR;
		case 'FOREVER':
			return $author$project$ApiSchemas$Deal$FOREVER;
		default:
			var unknown = value;
			return $author$project$ApiSchemas$Deal$UnknownTimescale(unknown);
	}
};
var $author$project$ApiSchemas$Deal$priceDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$ApiSchemas$Deal$Price,
	A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'currency', $author$project$ApiSchemas$Currency$decoder),
	A2(
		$elm$json$Json$Decode$field,
		'timescale',
		A2($elm$json$Json$Decode$map, $author$project$ApiSchemas$Deal$parseTimescale, $elm$json$Json$Decode$string)));
var $author$project$ApiSchemas$Deal$price = A2($author$project$ApiSchemas$attr, 'price', $author$project$ApiSchemas$Deal$priceDecoder);
var $author$project$Carwow$StockDealCard$Data$dealPricingDecoder = function (dealType) {
	switch (dealType.$) {
		case 0:
			return A2($elm$json$Json$Decode$map, $author$project$Carwow$StockDealCard$Data$CashPricing, $author$project$ApiSchemas$Deal$price);
		case 4:
			return $elm$json$Json$Decode$succeed($author$project$Carwow$StockDealCard$Data$PriceOnApplication);
		default:
			return $elm$json$Json$Decode$fail('Deal type not supported');
	}
};
var $author$project$ApiSchemas$Deal$BCH = {$: 3};
var $author$project$ApiSchemas$Deal$CASH = {$: 0};
var $author$project$ApiSchemas$Deal$PCH = {$: 2};
var $author$project$ApiSchemas$Deal$PCP = {$: 1};
var $author$project$ApiSchemas$Deal$POA = {$: 4};
var $author$project$ApiSchemas$Deal$UnknownType = function (a) {
	return {$: 5, a: a};
};
var $author$project$ApiSchemas$Deal$parseType = function (value) {
	switch (value) {
		case 'CASH':
			return $author$project$ApiSchemas$Deal$CASH;
		case 'PCP':
			return $author$project$ApiSchemas$Deal$PCP;
		case 'PCH':
			return $author$project$ApiSchemas$Deal$PCH;
		case 'BCH':
			return $author$project$ApiSchemas$Deal$BCH;
		case 'POA':
			return $author$project$ApiSchemas$Deal$POA;
		default:
			var unknown = value;
			return $author$project$ApiSchemas$Deal$UnknownType(unknown);
	}
};
var $author$project$ApiSchemas$Deal$dealType = A2(
	$author$project$ApiSchemas$attr,
	'type',
	A2($elm$json$Json$Decode$map, $author$project$ApiSchemas$Deal$parseType, $elm$json$Json$Decode$string));
var $author$project$ApiSchemas$Supplier$Supplier = F4(
	function (id, name, deliveryOnly, location) {
		return {cF: deliveryOnly, c1: id, da: location, di: name};
	});
var $author$project$ApiSchemas$Supplier$deliveryOnly = A2($author$project$ApiSchemas$attr, 'deliveryOnly', $elm$json$Json$Decode$bool);
var $author$project$ApiSchemas$id = A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string);
var $author$project$ApiSchemas$Supplier$id = $author$project$ApiSchemas$id;
var $author$project$ApiSchemas$Supplier$Location = F3(
	function (address, latitude, longitude) {
		return {ck: address, c8: latitude, db: longitude};
	});
var $author$project$ApiSchemas$Supplier$locationDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$ApiSchemas$Supplier$Location,
	A2($elm$json$Json$Decode$field, 'address', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'latitude', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'longitude', $elm$json$Json$Decode$float));
var $author$project$ApiSchemas$Supplier$location = A2($author$project$ApiSchemas$attr, 'location', $author$project$ApiSchemas$Supplier$locationDecoder);
var $elm$json$Json$Decode$map4 = _Json_map4;
var $author$project$ApiSchemas$Supplier$name = A2($author$project$ApiSchemas$attr, 'name', $elm$json$Json$Decode$string);
var $author$project$ApiSchemas$Supplier$decoder = A5($elm$json$Json$Decode$map4, $author$project$ApiSchemas$Supplier$Supplier, $author$project$ApiSchemas$Supplier$id, $author$project$ApiSchemas$Supplier$name, $author$project$ApiSchemas$Supplier$deliveryOnly, $author$project$ApiSchemas$Supplier$location);
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $author$project$ApiSchemas$maybeResolveResource = F3(
	function (_v0, decoder, identifier) {
		var included = _v0.bx;
		return A2(
			$elm$core$Maybe$map,
			$elm$json$Json$Decode$decodeValue(decoder),
			A2($elm$core$Dict$get, identifier, included));
	});
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $author$project$ApiSchemas$resourceNotFound = function (_v0) {
	var type_ = _v0.a;
	var id_ = _v0.b;
	return $elm$core$String$concat(
		_List_fromArray(
			['Resource { type = \"', type_, '\", id = \"', id_, '\" } not found in document']));
};
var $author$project$ApiSchemas$resultToDecoder = function (result) {
	if (!result.$) {
		var decoded = result.a;
		return $elm$json$Json$Decode$succeed(decoded);
	} else {
		var error = result.a;
		return $elm$json$Json$Decode$fail(
			$elm$json$Json$Decode$errorToString(error));
	}
};
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$ApiSchemas$resolveResource = F3(
	function (doc, decoder, identifier) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Decode$fail(
				$author$project$ApiSchemas$resourceNotFound(identifier)),
			A2(
				$elm$core$Maybe$map,
				$author$project$ApiSchemas$resultToDecoder,
				A3($author$project$ApiSchemas$maybeResolveResource, doc, decoder, identifier)));
	});
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $author$project$ApiSchemas$resourceType = A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string);
var $author$project$ApiSchemas$resourceIdentifier = A3($elm$json$Json$Decode$map2, $elm$core$Tuple$pair, $author$project$ApiSchemas$resourceType, $author$project$ApiSchemas$id);
var $author$project$ApiSchemas$hasOne = F3(
	function (doc, name, decoder) {
		return A2(
			$elm$json$Json$Decode$andThen,
			A2($author$project$ApiSchemas$resolveResource, doc, decoder),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['relationships', name, 'data']),
				$author$project$ApiSchemas$resourceIdentifier));
	});
var $author$project$ApiSchemas$Deal$supplier = function (doc) {
	return A2($author$project$ApiSchemas$hasOne, doc, 'supplier');
};
var $author$project$ApiSchemas$Deal$vehicle = function (doc) {
	return A2($author$project$ApiSchemas$hasOne, doc, 'vehicle');
};
var $author$project$Carwow$StockDealCard$Data$Vehicle = function (brandName) {
	return function (modelName) {
		return function (trimName) {
			return function (state) {
				return function (images) {
					return function (registrationDate) {
						return function (distanceTravelled) {
							return function (engine) {
								return function (fuel) {
									return function (transmission) {
										return function (prices) {
											return function (modelReview) {
												return function (derivative) {
													return function (id) {
														return {cp: brandName, cG: derivative, cK: distanceTravelled, cQ: engine, cV: fuel, c1: id, c3: images, df: modelName, dg: modelReview, dp: prices, dv: registrationDate, dG: state, dV: transmission, dW: trimName};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$ApiSchemas$and = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $author$project$ApiSchemas$Vehicle$brand = function (doc) {
	return A2($author$project$ApiSchemas$hasOne, doc, 'brand');
};
var $author$project$ApiSchemas$Vehicle$Derivative$Derivative = F2(
	function (id, legacyId) {
		return {c1: id, c9: legacyId};
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $author$project$ApiSchemas$Vehicle$Derivative$decoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$ApiSchemas$Vehicle$Derivative$Derivative,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$String$fromInt,
		A2($elm$json$Json$Decode$field, 'legacyId', $elm$json$Json$Decode$int)));
var $author$project$ApiSchemas$Vehicle$derivative = A2($author$project$ApiSchemas$attr, 'derivative', $author$project$ApiSchemas$Vehicle$Derivative$decoder);
var $author$project$ApiSchemas$Vehicle$DistanceUnit$KM = {$: 0};
var $author$project$ApiSchemas$Vehicle$DistanceUnit$MILE = {$: 1};
var $author$project$ApiSchemas$Vehicle$DistanceUnit$UnknownDistanceUnit = function (a) {
	return {$: 2, a: a};
};
var $author$project$ApiSchemas$Vehicle$DistanceUnit$parse = function (value) {
	switch (value) {
		case 'KM':
			return $author$project$ApiSchemas$Vehicle$DistanceUnit$KM;
		case 'MILE':
			return $author$project$ApiSchemas$Vehicle$DistanceUnit$MILE;
		default:
			var unknown = value;
			return $author$project$ApiSchemas$Vehicle$DistanceUnit$UnknownDistanceUnit(unknown);
	}
};
var $author$project$ApiSchemas$Vehicle$DistanceUnit$decoder = A2($elm$json$Json$Decode$map, $author$project$ApiSchemas$Vehicle$DistanceUnit$parse, $elm$json$Json$Decode$string);
var $author$project$ApiSchemas$Vehicle$ValueUnit$ValueUnit = F2(
	function (value, unit) {
		return {dX: unit, d_: value};
	});
var $author$project$ApiSchemas$Vehicle$ValueUnit$decoder = F2(
	function (value, unit) {
		return A3(
			$elm$json$Json$Decode$map2,
			$author$project$ApiSchemas$Vehicle$ValueUnit$ValueUnit,
			A2($elm$json$Json$Decode$field, 'value', value),
			A2($elm$json$Json$Decode$field, 'unit', unit));
	});
var $author$project$ApiSchemas$Vehicle$distanceTravelledDecoder = A2($author$project$ApiSchemas$Vehicle$ValueUnit$decoder, $elm$json$Json$Decode$int, $author$project$ApiSchemas$Vehicle$DistanceUnit$decoder);
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $author$project$ApiSchemas$Vehicle$distanceTravelled = A2(
	$author$project$ApiSchemas$attr,
	'distanceTravelled',
	$elm$json$Json$Decode$nullable($author$project$ApiSchemas$Vehicle$distanceTravelledDecoder));
var $author$project$ApiSchemas$Vehicle$Engine = F4(
	function (cc, name, power, size) {
		return {cs: cc, di: name, dn: power, dC: size};
	});
var $author$project$ApiSchemas$Vehicle$CC = {$: 1};
var $author$project$ApiSchemas$Vehicle$LITRE = {$: 0};
var $author$project$ApiSchemas$Vehicle$UnknownEngineSizeUnit = function (a) {
	return {$: 2, a: a};
};
var $author$project$ApiSchemas$Vehicle$parseEngineSizeUnit = function (value) {
	switch (value) {
		case 'LITRE':
			return $author$project$ApiSchemas$Vehicle$LITRE;
		case 'CC':
			return $author$project$ApiSchemas$Vehicle$CC;
		default:
			var unknown = value;
			return $author$project$ApiSchemas$Vehicle$UnknownEngineSizeUnit(unknown);
	}
};
var $author$project$ApiSchemas$Vehicle$engineSizeDecoder = A2(
	$author$project$ApiSchemas$Vehicle$ValueUnit$decoder,
	$elm$json$Json$Decode$float,
	A2($elm$json$Json$Decode$map, $author$project$ApiSchemas$Vehicle$parseEngineSizeUnit, $elm$json$Json$Decode$string));
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$ApiSchemas$Vehicle$BHP = {$: 0};
var $author$project$ApiSchemas$Vehicle$KW = {$: 1};
var $author$project$ApiSchemas$Vehicle$PS = {$: 2};
var $author$project$ApiSchemas$Vehicle$UnknownPowerUnit = function (a) {
	return {$: 3, a: a};
};
var $author$project$ApiSchemas$Vehicle$parsePowerUnit = function (value) {
	switch (value) {
		case 'BHP':
			return $author$project$ApiSchemas$Vehicle$BHP;
		case 'KW':
			return $author$project$ApiSchemas$Vehicle$KW;
		case 'PS':
			return $author$project$ApiSchemas$Vehicle$PS;
		default:
			var unknown = value;
			return $author$project$ApiSchemas$Vehicle$UnknownPowerUnit(unknown);
	}
};
var $author$project$ApiSchemas$Vehicle$powerDecoder = A2(
	$author$project$ApiSchemas$Vehicle$ValueUnit$decoder,
	$elm$json$Json$Decode$int,
	A2($elm$json$Json$Decode$map, $author$project$ApiSchemas$Vehicle$parsePowerUnit, $elm$json$Json$Decode$string));
var $author$project$ApiSchemas$Vehicle$engineDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$ApiSchemas$Vehicle$Engine,
	A2(
		$elm$json$Json$Decode$field,
		'cc',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int)),
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'power',
		$elm$json$Json$Decode$list($author$project$ApiSchemas$Vehicle$powerDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'size',
		$elm$json$Json$Decode$list($author$project$ApiSchemas$Vehicle$engineSizeDecoder)));
var $author$project$ApiSchemas$Vehicle$engine = A2($author$project$ApiSchemas$attr, 'engine', $author$project$ApiSchemas$Vehicle$engineDecoder);
var $author$project$ApiSchemas$Vehicle$Fuel$Fuel = F6(
	function (name, category, primary, hybridType, range, consumption) {
		return {cr: category, cx: consumption, c$: hybridType, di: name, ds: primary, dt: range};
	});
var $author$project$ApiSchemas$Vehicle$Fuel$KML = {$: 1};
var $author$project$ApiSchemas$Vehicle$Fuel$KWHP100KM = {$: 3};
var $author$project$ApiSchemas$Vehicle$Fuel$LP100KM = {$: 4};
var $author$project$ApiSchemas$Vehicle$Fuel$MPG = {$: 0};
var $author$project$ApiSchemas$Vehicle$Fuel$MPKWH = {$: 2};
var $author$project$ApiSchemas$Vehicle$Fuel$UnknownConsumptionUnit = function (a) {
	return {$: 5, a: a};
};
var $author$project$ApiSchemas$Vehicle$Fuel$parseConsumptionUnit = function (value) {
	switch (value) {
		case 'MPG':
			return $author$project$ApiSchemas$Vehicle$Fuel$MPG;
		case 'KML':
			return $author$project$ApiSchemas$Vehicle$Fuel$KML;
		case 'MPKWH':
			return $author$project$ApiSchemas$Vehicle$Fuel$MPKWH;
		case 'KWHP100KM':
			return $author$project$ApiSchemas$Vehicle$Fuel$KWHP100KM;
		case 'LP100KM':
			return $author$project$ApiSchemas$Vehicle$Fuel$LP100KM;
		default:
			var unknown = value;
			return $author$project$ApiSchemas$Vehicle$Fuel$UnknownConsumptionUnit(unknown);
	}
};
var $author$project$ApiSchemas$Vehicle$Fuel$consumptionDecoder = A2(
	$author$project$ApiSchemas$Vehicle$ValueUnit$decoder,
	$elm$json$Json$Decode$float,
	A2($elm$json$Json$Decode$map, $author$project$ApiSchemas$Vehicle$Fuel$parseConsumptionUnit, $elm$json$Json$Decode$string));
var $author$project$ApiSchemas$Vehicle$Fuel$Category$Diesel = {$: 0};
var $author$project$ApiSchemas$Vehicle$Fuel$Category$Electric = {$: 1};
var $author$project$ApiSchemas$Vehicle$Fuel$Category$Hybrid = {$: 2};
var $author$project$ApiSchemas$Vehicle$Fuel$Category$Hydrogen = {$: 3};
var $author$project$ApiSchemas$Vehicle$Fuel$Category$Petrol = {$: 4};
var $author$project$ApiSchemas$Vehicle$Fuel$Category$Unknown = function (a) {
	return {$: 5, a: a};
};
var $author$project$ApiSchemas$Vehicle$Fuel$Category$parse = function (value) {
	switch (value) {
		case 'diesel':
			return $author$project$ApiSchemas$Vehicle$Fuel$Category$Diesel;
		case 'electric':
			return $author$project$ApiSchemas$Vehicle$Fuel$Category$Electric;
		case 'hybrid':
			return $author$project$ApiSchemas$Vehicle$Fuel$Category$Hybrid;
		case 'hydrogen':
			return $author$project$ApiSchemas$Vehicle$Fuel$Category$Hydrogen;
		case 'petrol':
			return $author$project$ApiSchemas$Vehicle$Fuel$Category$Petrol;
		default:
			var unknown = value;
			return $author$project$ApiSchemas$Vehicle$Fuel$Category$Unknown(unknown);
	}
};
var $author$project$ApiSchemas$Vehicle$Fuel$Category$decoder = A2($elm$json$Json$Decode$map, $author$project$ApiSchemas$Vehicle$Fuel$Category$parse, $elm$json$Json$Decode$string);
var $author$project$ApiSchemas$Vehicle$Fuel$HybridType$BEV = {$: 6};
var $author$project$ApiSchemas$Vehicle$Fuel$HybridType$EREV = {$: 5};
var $author$project$ApiSchemas$Vehicle$Fuel$HybridType$FCEV = {$: 2};
var $author$project$ApiSchemas$Vehicle$Fuel$HybridType$HEV = {$: 0};
var $author$project$ApiSchemas$Vehicle$Fuel$HybridType$MHEV = {$: 4};
var $author$project$ApiSchemas$Vehicle$Fuel$HybridType$PHEV = {$: 1};
var $author$project$ApiSchemas$Vehicle$Fuel$HybridType$RHEV = {$: 3};
var $author$project$ApiSchemas$Vehicle$Fuel$HybridType$Unknown = function (a) {
	return {$: 7, a: a};
};
var $author$project$ApiSchemas$Vehicle$Fuel$HybridType$parse = function (value) {
	switch (value) {
		case 'HEV':
			return $author$project$ApiSchemas$Vehicle$Fuel$HybridType$HEV;
		case 'PHEV':
			return $author$project$ApiSchemas$Vehicle$Fuel$HybridType$PHEV;
		case 'FCEV':
			return $author$project$ApiSchemas$Vehicle$Fuel$HybridType$FCEV;
		case 'RHEV':
			return $author$project$ApiSchemas$Vehicle$Fuel$HybridType$RHEV;
		case 'MHEV':
			return $author$project$ApiSchemas$Vehicle$Fuel$HybridType$MHEV;
		case 'EREV':
			return $author$project$ApiSchemas$Vehicle$Fuel$HybridType$EREV;
		case 'BEV':
			return $author$project$ApiSchemas$Vehicle$Fuel$HybridType$BEV;
		default:
			var unknown = value;
			return $author$project$ApiSchemas$Vehicle$Fuel$HybridType$Unknown(unknown);
	}
};
var $author$project$ApiSchemas$Vehicle$Fuel$HybridType$decoder = A2($elm$json$Json$Decode$map, $author$project$ApiSchemas$Vehicle$Fuel$HybridType$parse, $elm$json$Json$Decode$string);
var $author$project$ApiSchemas$Vehicle$Fuel$Name$Diesel = {$: 0};
var $author$project$ApiSchemas$Vehicle$Fuel$Name$DieselBio = {$: 1};
var $author$project$ApiSchemas$Vehicle$Fuel$Name$DieselHybrid = {$: 2};
var $author$project$ApiSchemas$Vehicle$Fuel$Name$DieselPluginHybrid = {$: 3};
var $author$project$ApiSchemas$Vehicle$Fuel$Name$Electric = {$: 4};
var $author$project$ApiSchemas$Vehicle$Fuel$Name$Hybrid = {$: 5};
var $author$project$ApiSchemas$Vehicle$Fuel$Name$HydrogenFuelCell = {$: 6};
var $author$project$ApiSchemas$Vehicle$Fuel$Name$Petrol = {$: 7};
var $author$project$ApiSchemas$Vehicle$Fuel$Name$PetrolBiogas = {$: 8};
var $author$project$ApiSchemas$Vehicle$Fuel$Name$PetrolGas = {$: 9};
var $author$project$ApiSchemas$Vehicle$Fuel$Name$PetrolHybrid = {$: 10};
var $author$project$ApiSchemas$Vehicle$Fuel$Name$PetrolLpg = {$: 11};
var $author$project$ApiSchemas$Vehicle$Fuel$Name$PetrolPluginHybrid = {$: 12};
var $author$project$ApiSchemas$Vehicle$Fuel$Name$Unknown = function (a) {
	return {$: 13, a: a};
};
var $author$project$ApiSchemas$Vehicle$Fuel$Name$parse = function (value) {
	switch (value) {
		case 'diesel':
			return $author$project$ApiSchemas$Vehicle$Fuel$Name$Diesel;
		case 'diesel-bio':
			return $author$project$ApiSchemas$Vehicle$Fuel$Name$DieselBio;
		case 'diesel-hybrid':
			return $author$project$ApiSchemas$Vehicle$Fuel$Name$DieselHybrid;
		case 'diesel-plugin-hybrid':
			return $author$project$ApiSchemas$Vehicle$Fuel$Name$DieselPluginHybrid;
		case 'electric':
			return $author$project$ApiSchemas$Vehicle$Fuel$Name$Electric;
		case 'hybrid':
			return $author$project$ApiSchemas$Vehicle$Fuel$Name$Hybrid;
		case 'hydrogen-fuel-cell':
			return $author$project$ApiSchemas$Vehicle$Fuel$Name$HydrogenFuelCell;
		case 'petrol':
			return $author$project$ApiSchemas$Vehicle$Fuel$Name$Petrol;
		case 'petrol-biogas':
			return $author$project$ApiSchemas$Vehicle$Fuel$Name$PetrolBiogas;
		case 'petrol-gas':
			return $author$project$ApiSchemas$Vehicle$Fuel$Name$PetrolGas;
		case 'petrol-hybrid':
			return $author$project$ApiSchemas$Vehicle$Fuel$Name$PetrolHybrid;
		case 'petrol-lpg':
			return $author$project$ApiSchemas$Vehicle$Fuel$Name$PetrolLpg;
		case 'petrol-plugin-hybrid':
			return $author$project$ApiSchemas$Vehicle$Fuel$Name$PetrolPluginHybrid;
		default:
			var unknown = value;
			return $author$project$ApiSchemas$Vehicle$Fuel$Name$Unknown(unknown);
	}
};
var $author$project$ApiSchemas$Vehicle$Fuel$Name$decoder = A2($elm$json$Json$Decode$map, $author$project$ApiSchemas$Vehicle$Fuel$Name$parse, $elm$json$Json$Decode$string);
var $author$project$ApiSchemas$Vehicle$Fuel$Primary$Diesel = {$: 0};
var $author$project$ApiSchemas$Vehicle$Fuel$Primary$Electric = {$: 1};
var $author$project$ApiSchemas$Vehicle$Fuel$Primary$Hydrogen = {$: 2};
var $author$project$ApiSchemas$Vehicle$Fuel$Primary$Petrol = {$: 3};
var $author$project$ApiSchemas$Vehicle$Fuel$Primary$Unknown = function (a) {
	return {$: 4, a: a};
};
var $author$project$ApiSchemas$Vehicle$Fuel$Primary$parse = function (value) {
	switch (value) {
		case 'diesel':
			return $author$project$ApiSchemas$Vehicle$Fuel$Primary$Diesel;
		case 'electric':
			return $author$project$ApiSchemas$Vehicle$Fuel$Primary$Electric;
		case 'hydrogen':
			return $author$project$ApiSchemas$Vehicle$Fuel$Primary$Hydrogen;
		case 'petrol':
			return $author$project$ApiSchemas$Vehicle$Fuel$Primary$Petrol;
		default:
			var unknown = value;
			return $author$project$ApiSchemas$Vehicle$Fuel$Primary$Unknown(unknown);
	}
};
var $author$project$ApiSchemas$Vehicle$Fuel$Primary$decoder = A2($elm$json$Json$Decode$map, $author$project$ApiSchemas$Vehicle$Fuel$Primary$parse, $elm$json$Json$Decode$string);
var $elm$json$Json$Decode$map6 = _Json_map6;
var $author$project$ApiSchemas$Vehicle$Fuel$Range = function (electric) {
	return {cO: electric};
};
var $author$project$ApiSchemas$Vehicle$Fuel$rangeValueDecoder = A2($author$project$ApiSchemas$Vehicle$ValueUnit$decoder, $elm$json$Json$Decode$float, $author$project$ApiSchemas$Vehicle$DistanceUnit$decoder);
var $author$project$ApiSchemas$Vehicle$Fuel$rangeDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$ApiSchemas$Vehicle$Fuel$Range,
	A2($elm$json$Json$Decode$field, 'electric', $author$project$ApiSchemas$Vehicle$Fuel$rangeValueDecoder));
var $author$project$ApiSchemas$Vehicle$Fuel$decoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$ApiSchemas$Vehicle$Fuel$Fuel,
	A2($elm$json$Json$Decode$field, 'name', $author$project$ApiSchemas$Vehicle$Fuel$Name$decoder),
	A2($elm$json$Json$Decode$field, 'category', $author$project$ApiSchemas$Vehicle$Fuel$Category$decoder),
	A2($elm$json$Json$Decode$field, 'primary', $author$project$ApiSchemas$Vehicle$Fuel$Primary$decoder),
	A2(
		$elm$json$Json$Decode$field,
		'hybridType',
		$elm$json$Json$Decode$nullable($author$project$ApiSchemas$Vehicle$Fuel$HybridType$decoder)),
	A2(
		$elm$json$Json$Decode$field,
		'range',
		$elm$json$Json$Decode$nullable($author$project$ApiSchemas$Vehicle$Fuel$rangeDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'consumption',
		$elm$json$Json$Decode$list($author$project$ApiSchemas$Vehicle$Fuel$consumptionDecoder)));
var $author$project$ApiSchemas$Vehicle$fuel = A2($author$project$ApiSchemas$attr, 'fuel', $author$project$ApiSchemas$Vehicle$Fuel$decoder);
var $author$project$ApiSchemas$Vehicle$id = $author$project$ApiSchemas$id;
var $author$project$ApiSchemas$Vehicle$Image$Image = F3(
	function (imageType, angle, url) {
		return {cm: angle, c2: imageType, dZ: url};
	});
var $author$project$ApiSchemas$Vehicle$Image$Front = {$: 0};
var $author$project$ApiSchemas$Vehicle$Image$OtherAngle = function (a) {
	return {$: 4, a: a};
};
var $author$project$ApiSchemas$Vehicle$Image$Rear = {$: 2};
var $author$project$ApiSchemas$Vehicle$Image$Side = {$: 1};
var $author$project$ApiSchemas$Vehicle$Image$UnknownAngle = {$: 3};
var $author$project$ApiSchemas$Vehicle$Image$parseAngle = function (value) {
	switch (value) {
		case 'front':
			return $author$project$ApiSchemas$Vehicle$Image$Front;
		case 'side':
			return $author$project$ApiSchemas$Vehicle$Image$Side;
		case 'rear':
			return $author$project$ApiSchemas$Vehicle$Image$Rear;
		case 'unknown':
			return $author$project$ApiSchemas$Vehicle$Image$UnknownAngle;
		default:
			var other = value;
			return $author$project$ApiSchemas$Vehicle$Image$OtherAngle(other);
	}
};
var $author$project$ApiSchemas$Vehicle$Image$Custom = {$: 0};
var $author$project$ApiSchemas$Vehicle$Image$Imagin = {$: 1};
var $author$project$ApiSchemas$Vehicle$Image$Izmo = {$: 2};
var $author$project$ApiSchemas$Vehicle$Image$UnknownType = function (a) {
	return {$: 3, a: a};
};
var $author$project$ApiSchemas$Vehicle$Image$parseType = function (value) {
	switch (value) {
		case 'custom':
			return $author$project$ApiSchemas$Vehicle$Image$Custom;
		case 'imagin':
			return $author$project$ApiSchemas$Vehicle$Image$Imagin;
		case 'izmo':
			return $author$project$ApiSchemas$Vehicle$Image$Izmo;
		default:
			var unknown = value;
			return $author$project$ApiSchemas$Vehicle$Image$UnknownType(unknown);
	}
};
var $author$project$ApiSchemas$Vehicle$Image$decoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$ApiSchemas$Vehicle$Image$Image,
	A2(
		$elm$json$Json$Decode$field,
		'type',
		A2($elm$json$Json$Decode$map, $author$project$ApiSchemas$Vehicle$Image$parseType, $elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$field,
		'angle',
		A2($elm$json$Json$Decode$map, $author$project$ApiSchemas$Vehicle$Image$parseAngle, $elm$json$Json$Decode$string)),
	A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string));
var $author$project$ApiSchemas$Vehicle$images = A2(
	$author$project$ApiSchemas$attr,
	'images',
	$elm$json$Json$Decode$list($author$project$ApiSchemas$Vehicle$Image$decoder));
var $author$project$ApiSchemas$Vehicle$model = function (doc) {
	return A2($author$project$ApiSchemas$hasOne, doc, 'model');
};
var $author$project$ApiSchemas$Vehicle$ModelReview$ModelReview = F2(
	function (slug, name) {
		return {di: name, dD: slug};
	});
var $author$project$ApiSchemas$Vehicle$ModelReview$name = A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string);
var $author$project$ApiSchemas$Vehicle$ModelReview$slug = A2($elm$json$Json$Decode$field, 'slug', $elm$json$Json$Decode$string);
var $author$project$ApiSchemas$Vehicle$ModelReview$decoder = A3($elm$json$Json$Decode$map2, $author$project$ApiSchemas$Vehicle$ModelReview$ModelReview, $author$project$ApiSchemas$Vehicle$ModelReview$slug, $author$project$ApiSchemas$Vehicle$ModelReview$name);
var $author$project$ApiSchemas$Vehicle$modelReview = A2($author$project$ApiSchemas$attr, 'modelReview', $author$project$ApiSchemas$Vehicle$ModelReview$decoder);
var $author$project$ApiSchemas$Brand$name = A2($author$project$ApiSchemas$attr, 'name', $elm$json$Json$Decode$string);
var $author$project$ApiSchemas$Model$name = A2($author$project$ApiSchemas$attr, 'name', $elm$json$Json$Decode$string);
var $author$project$ApiSchemas$Vehicle$Prices$Prices = F3(
	function (rrp, market, unit) {
		return {dc: market, dz: rrp, dX: unit};
	});
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $author$project$ApiSchemas$Vehicle$Prices$decoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$ApiSchemas$Vehicle$Prices$Prices,
	A2($elm$json$Json$Decode$field, 'rrp', $elm$json$Json$Decode$float),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'market', $elm$json$Json$Decode$float)),
	A2($elm$json$Json$Decode$field, 'unit', $author$project$ApiSchemas$Currency$decoder));
var $author$project$ApiSchemas$Vehicle$prices = A2($author$project$ApiSchemas$attr, 'prices', $author$project$ApiSchemas$Vehicle$Prices$decoder);
var $author$project$ApiSchemas$Vehicle$Registration = function (date) {
	return {cB: date};
};
var $author$project$ApiSchemas$Vehicle$registrationDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$ApiSchemas$Vehicle$Registration,
	A2(
		$elm$json$Json$Decode$field,
		'date',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)));
var $author$project$ApiSchemas$Vehicle$registration = A2($author$project$ApiSchemas$attr, 'registration', $author$project$ApiSchemas$Vehicle$registrationDecoder);
var $author$project$ApiSchemas$Vehicle$NEARLYNEW = {$: 3};
var $author$project$ApiSchemas$Vehicle$PREREGISTERED = {$: 2};
var $author$project$ApiSchemas$Vehicle$UNBUILT = {$: 0};
var $author$project$ApiSchemas$Vehicle$UNREGISTERED = {$: 1};
var $author$project$ApiSchemas$Vehicle$USED = {$: 4};
var $author$project$ApiSchemas$Vehicle$UnknownState = function (a) {
	return {$: 5, a: a};
};
var $author$project$ApiSchemas$Vehicle$parseState = function (value) {
	switch (value) {
		case 'UNBUILT':
			return $author$project$ApiSchemas$Vehicle$UNBUILT;
		case 'UNREGISTERED':
			return $author$project$ApiSchemas$Vehicle$UNREGISTERED;
		case 'PREREGISTERED':
			return $author$project$ApiSchemas$Vehicle$PREREGISTERED;
		case 'NEARLYNEW':
			return $author$project$ApiSchemas$Vehicle$NEARLYNEW;
		case 'USED':
			return $author$project$ApiSchemas$Vehicle$USED;
		default:
			var unknown = value;
			return $author$project$ApiSchemas$Vehicle$UnknownState(unknown);
	}
};
var $author$project$ApiSchemas$Vehicle$state = A2(
	$author$project$ApiSchemas$attr,
	'state',
	A2($elm$json$Json$Decode$map, $author$project$ApiSchemas$Vehicle$parseState, $elm$json$Json$Decode$string));
var $author$project$ApiSchemas$Vehicle$Transmission$Transmission = F3(
	function (slug, category, speeds) {
		return {cr: category, dD: slug, dE: speeds};
	});
var $author$project$ApiSchemas$Vehicle$Transmission$Category$Automatic = {$: 1};
var $author$project$ApiSchemas$Vehicle$Transmission$Category$Manual = {$: 0};
var $author$project$ApiSchemas$Vehicle$Transmission$Category$Unknown = function (a) {
	return {$: 2, a: a};
};
var $author$project$ApiSchemas$Vehicle$Transmission$Category$parse = function (value) {
	switch (value) {
		case 'manual':
			return $author$project$ApiSchemas$Vehicle$Transmission$Category$Manual;
		case 'automatic':
			return $author$project$ApiSchemas$Vehicle$Transmission$Category$Automatic;
		default:
			var unknown = value;
			return $author$project$ApiSchemas$Vehicle$Transmission$Category$Unknown(unknown);
	}
};
var $author$project$ApiSchemas$Vehicle$Transmission$Category$decoder = A2($elm$json$Json$Decode$map, $author$project$ApiSchemas$Vehicle$Transmission$Category$parse, $elm$json$Json$Decode$string);
var $author$project$ApiSchemas$Vehicle$Transmission$decoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$ApiSchemas$Vehicle$Transmission$Transmission,
	A2($elm$json$Json$Decode$field, 'slug', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'category', $author$project$ApiSchemas$Vehicle$Transmission$Category$decoder),
	A2(
		$elm$json$Json$Decode$field,
		'speeds',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int)));
var $author$project$ApiSchemas$Vehicle$transmission = A2($author$project$ApiSchemas$attr, 'transmission', $author$project$ApiSchemas$Vehicle$Transmission$decoder);
var $author$project$ApiSchemas$Vehicle$Trim = F3(
	function (slug, name, description) {
		return {cI: description, di: name, dD: slug};
	});
var $author$project$ApiSchemas$Vehicle$trimDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$ApiSchemas$Vehicle$Trim,
	A2($elm$json$Json$Decode$field, 'slug', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'description',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)));
var $author$project$ApiSchemas$Vehicle$trim = A2($author$project$ApiSchemas$attr, 'trim', $author$project$ApiSchemas$Vehicle$trimDecoder);
var $author$project$Carwow$StockDealCard$Data$vehicleDecoder = function (doc) {
	return A2(
		$author$project$ApiSchemas$and,
		$author$project$ApiSchemas$Vehicle$id,
		A2(
			$author$project$ApiSchemas$and,
			$author$project$ApiSchemas$Vehicle$derivative,
			A2(
				$author$project$ApiSchemas$and,
				$author$project$ApiSchemas$Vehicle$modelReview,
				A2(
					$author$project$ApiSchemas$and,
					$author$project$ApiSchemas$Vehicle$prices,
					A2(
						$author$project$ApiSchemas$and,
						$author$project$ApiSchemas$Vehicle$transmission,
						A2(
							$author$project$ApiSchemas$and,
							$author$project$ApiSchemas$Vehicle$fuel,
							A2(
								$author$project$ApiSchemas$and,
								$author$project$ApiSchemas$Vehicle$engine,
								A2(
									$author$project$ApiSchemas$and,
									$author$project$ApiSchemas$Vehicle$distanceTravelled,
									A2(
										$author$project$ApiSchemas$and,
										A2(
											$elm$json$Json$Decode$map,
											function ($) {
												return $.cB;
											},
											$author$project$ApiSchemas$Vehicle$registration),
										A2(
											$author$project$ApiSchemas$and,
											$author$project$ApiSchemas$Vehicle$images,
											A2(
												$author$project$ApiSchemas$and,
												$author$project$ApiSchemas$Vehicle$state,
												A2(
													$author$project$ApiSchemas$and,
													A2(
														$elm$json$Json$Decode$map,
														function ($) {
															return $.di;
														},
														$author$project$ApiSchemas$Vehicle$trim),
													A2(
														$author$project$ApiSchemas$and,
														A2($author$project$ApiSchemas$Vehicle$model, doc, $author$project$ApiSchemas$Model$name),
														A2(
															$author$project$ApiSchemas$and,
															A2($author$project$ApiSchemas$Vehicle$brand, doc, $author$project$ApiSchemas$Brand$name),
															$elm$json$Json$Decode$succeed($author$project$Carwow$StockDealCard$Data$Vehicle)))))))))))))));
};
var $author$project$Carwow$StockDealCard$Data$dealDecoder = function (doc) {
	return A4(
		$elm$json$Json$Decode$map3,
		$author$project$Carwow$StockDealCard$Data$Deal,
		A2($elm$json$Json$Decode$andThen, $author$project$Carwow$StockDealCard$Data$dealPricingDecoder, $author$project$ApiSchemas$Deal$dealType),
		A2(
			$author$project$ApiSchemas$Deal$vehicle,
			doc,
			$author$project$Carwow$StockDealCard$Data$vehicleDecoder(doc)),
		A2($author$project$ApiSchemas$Deal$supplier, doc, $author$project$ApiSchemas$Supplier$decoder));
};
var $author$project$Carwow$Http$Client = $elm$core$Basics$identity;
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $author$project$Carwow$Http$deleteHeader = F2(
	function (key, headersList) {
		return A2(
			$elm$core$List$filter,
			function (_v0) {
				var k = _v0.a;
				return !_Utils_eq(k, key);
			},
			headersList);
	});
var $author$project$Carwow$Http$addHeader = F2(
	function (_v0, headersList) {
		var key = _v0.a;
		var value = _v0.b;
		return A2(
			$elm$core$List$cons,
			_Utils_Tuple2(key, value),
			A2($author$project$Carwow$Http$deleteHeader, key, headersList));
	});
var $author$project$Carwow$Http$header = F3(
	function (key, value, _v0) {
		var client = _v0;
		return _Utils_update(
			client,
			{
				bu: A2(
					$author$project$Carwow$Http$addHeader,
					_Utils_Tuple2(key, value),
					client.bu)
			});
	});
var $author$project$Carwow$Http$methodForRequest = function (method) {
	switch (method) {
		case 0:
			return 'GET';
		case 1:
			return 'POST';
		case 2:
			return 'PATCH';
		case 3:
			return 'PUT';
		default:
			return 'DELETE';
	}
};
var $author$project$Carwow$Http$requestUrl = function (client) {
	return A2(client.P, client.ae, client.A);
};
var $author$project$Carwow$Http$toContext = function (_v0) {
	var client = _v0;
	return {
		bf: client.bf,
		bu: client.bu,
		de: $author$project$Carwow$Http$methodForRequest(client.de),
		dZ: $author$project$Carwow$Http$requestUrl(client)
	};
};
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $author$project$Carwow$Http$BadBody = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $author$project$Carwow$Http$decodeJson = F3(
	function (context, decoder, response) {
		return A2(
			$elm$core$Result$map,
			function (value) {
				return {bf: value, aa: context, bu: response.bu, b6: response.b6};
			},
			A2(
				$elm$core$Result$mapError,
				function (err) {
					return A2($author$project$Carwow$Http$BadBody, err, response);
				},
				A2(
					$elm$core$Result$mapError,
					$elm$json$Json$Decode$errorToString,
					A2($elm$json$Json$Decode$decodeString, decoder, response.bf))));
	});
var $author$project$Carwow$Http$BadStatus = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Carwow$Http$BadUrl = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Carwow$Http$NetworkError = function (a) {
	return {$: 2, a: a};
};
var $author$project$Carwow$Http$Timeout = function (a) {
	return {$: 1, a: a};
};
var $author$project$Carwow$Http$toResponse = F3(
	function (context, metadata, body_) {
		return {
			bf: body_,
			aa: context,
			bu: $elm$core$Dict$toList(metadata.bu),
			b6: metadata.b7
		};
	});
var $author$project$Carwow$Http$toDataString = F2(
	function (context, response) {
		switch (response.$) {
			case 0:
				var url_ = response.a;
				return $elm$core$Result$Err(
					A2($author$project$Carwow$Http$BadUrl, url_, context));
			case 1:
				return $elm$core$Result$Err(
					$author$project$Carwow$Http$Timeout(context));
			case 2:
				return $elm$core$Result$Err(
					$author$project$Carwow$Http$NetworkError(context));
			case 3:
				var metadata = response.a;
				var body_ = response.b;
				return $elm$core$Result$Err(
					A2(
						$author$project$Carwow$Http$BadStatus,
						metadata.b7,
						A3($author$project$Carwow$Http$toResponse, context, metadata, body_)));
			default:
				var metadata = response.a;
				var body_ = response.b;
				return $elm$core$Result$Ok(
					A3($author$project$Carwow$Http$toResponse, context, metadata, body_));
		}
	});
var $author$project$Carwow$Http$toDataJson = F3(
	function (decoder, context, response) {
		return A2(
			$elm$core$Result$andThen,
			A2($author$project$Carwow$Http$decodeJson, context, decoder),
			A2($author$project$Carwow$Http$toDataString, context, response));
	});
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {bZ: reqs, b9: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.dU;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.bZ));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.b9)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					cl: r.cl,
					bf: r.bf,
					cS: A2(_Http_mapExpect, func, r.cS),
					bu: r.bu,
					de: r.de,
					F: r.F,
					dU: r.dU,
					dZ: r.dZ
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{cl: false, bf: r.bf, cS: r.cS, bu: r.bu, de: r.de, F: r.F, dU: r.dU, dZ: r.dZ}));
};
var $elm$http$Http$riskyRequest = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{cl: true, bf: r.bf, cS: r.cS, bu: r.bu, de: r.de, F: r.F, dU: r.dU, dZ: r.dZ}));
};
var $author$project$Carwow$Http$toHttpRequest = F3(
	function (msg, responseToData, _v0) {
		var client = _v0;
		var request = {
			bf: client.bf,
			cS: A2($elm$http$Http$expectStringResponse, msg, responseToData),
			bu: A2(
				$elm$core$List$map,
				function (_v1) {
					var key = _v1.a;
					var val = _v1.b;
					return A2($elm$http$Http$header, key, val);
				},
				client.bu),
			de: $author$project$Carwow$Http$methodForRequest(client.de),
			F: client.F,
			dU: $elm$core$Maybe$Nothing,
			dZ: $author$project$Carwow$Http$requestUrl(client)
		};
		return client.X ? $elm$http$Http$riskyRequest(request) : $elm$http$Http$request(request);
	});
var $author$project$Carwow$Http$fetchJson = F3(
	function (decoder, msg, client) {
		return A3(
			$author$project$Carwow$Http$toHttpRequest,
			msg,
			A2(
				$author$project$Carwow$Http$toDataJson,
				decoder,
				$author$project$Carwow$Http$toContext(client)),
			A3($author$project$Carwow$Http$header, 'Accept', 'application/json', client));
	});
var $author$project$Carwow$Http$Get = 0;
var $author$project$Carwow$Http$get = function (_v0) {
	var client = _v0;
	return _Utils_update(
		client,
		{de: 0});
};
var $author$project$Carwow$Http$path = F2(
	function (endpoint, _v0) {
		var client = _v0;
		return _Utils_update(
			client,
			{ae: endpoint});
	});
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Carwow$Http$query = F2(
	function (params, _v0) {
		var client = _v0;
		var newParams = _Utils_ap(
			A2(
				$elm$core$List$map,
				function (_v1) {
					var k = _v1.a;
					var v = _v1.b;
					return A2($elm$url$Url$Builder$string, k, v);
				},
				params),
			client.A);
		return _Utils_update(
			client,
			{A: newParams});
	});
var $author$project$DealsServiceApi$getDeal = F5(
	function (id, params, decoder, msg, _v0) {
		var client = _v0;
		return A3(
			$author$project$Carwow$Http$fetchJson,
			decoder,
			msg,
			A2(
				$author$project$Carwow$Http$query,
				params,
				A2(
					$author$project$Carwow$Http$path,
					_List_fromArray(
						['api', 'deals', id]),
					$author$project$Carwow$Http$get(client))));
	});
var $author$project$DealsServiceApi$Client = $elm$core$Basics$identity;
var $author$project$Carwow$Http$auth = $author$project$Carwow$Http$header('Authorization');
var $author$project$DealsServiceApi$authClient = F2(
	function (jwt, _v0) {
		var client = _v0;
		return A2($author$project$Carwow$Http$auth, 'Bearer ' + jwt, client);
	});
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$crossOrigin = F3(
	function (prePath, pathSegments, parameters) {
		return prePath + ('/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters)));
	});
var $elm$url$Url$Builder$absolute = F2(
	function (pathSegments, parameters) {
		return '/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$Carwow$Http$defaultTimeoutSecs = 10;
var $author$project$Carwow$Http$secsToMs = function (secs) {
	return $elm$core$Maybe$Just(secs * 1000);
};
var $author$project$Carwow$Http$defaultTimeoutMs = $author$project$Carwow$Http$secsToMs($author$project$Carwow$Http$defaultTimeoutSecs);
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $author$project$Carwow$Http$defaultClient = {
	bf: $elm$http$Http$emptyBody,
	ae: _List_Nil,
	bu: _List_fromArray(
		[
			_Utils_Tuple2('X-User-Agent', 'carwow/browser (Carwow.Http 1.0.2)'),
			_Utils_Tuple2(
			'X-Client-Timeout',
			$elm$core$String$fromInt($author$project$Carwow$Http$defaultTimeoutSecs))
		]),
	P: $elm$url$Url$Builder$absolute,
	de: 0,
	A: _List_Nil,
	F: $author$project$Carwow$Http$defaultTimeoutMs,
	X: false
};
var $author$project$Carwow$Http$crossOrigin = function (host) {
	return _Utils_update(
		$author$project$Carwow$Http$defaultClient,
		{
			P: $elm$url$Url$Builder$crossOrigin(host)
		});
};
var $author$project$DealsServiceApi$initPublicClient = function (url) {
	return $author$project$Carwow$Http$crossOrigin(url);
};
var $author$project$DealsServiceApi$initAuthedClient = F2(
	function (url, jwt) {
		return A2(
			$author$project$DealsServiceApi$authClient,
			jwt,
			$author$project$DealsServiceApi$initPublicClient(url));
	});
var $author$project$ApiSchemas$data = function (decoder) {
	return $elm$json$Json$Decode$andThen(
		function (doc) {
			return A2(
				$elm$json$Json$Decode$field,
				'data',
				decoder(doc));
		});
};
var $author$project$ApiSchemas$Document = $elm$core$Basics$identity;
var $author$project$ApiSchemas$DocumentStruct = F2(
	function (document, included) {
		return {cL: document, bx: included};
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $author$project$ApiSchemas$includedResourceDecoder = A3($elm$json$Json$Decode$map2, $elm$core$Tuple$pair, $author$project$ApiSchemas$resourceIdentifier, $elm$json$Json$Decode$value);
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $author$project$ApiSchemas$includedResourcesDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			$elm$json$Json$Decode$list($author$project$ApiSchemas$includedResourceDecoder),
			A2($elm$json$Json$Decode$map, $elm$core$List$singleton, $author$project$ApiSchemas$includedResourceDecoder)
		]));
var $author$project$ApiSchemas$includedDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$Basics$append,
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2($elm$json$Json$Decode$field, 'data', $author$project$ApiSchemas$includedResourcesDecoder),
					$elm$json$Json$Decode$succeed(_List_Nil)
				])),
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2($elm$json$Json$Decode$field, 'included', $author$project$ApiSchemas$includedResourcesDecoder),
					$elm$json$Json$Decode$succeed(_List_Nil)
				]))));
var $author$project$ApiSchemas$document = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3($elm$json$Json$Decode$map2, $author$project$ApiSchemas$DocumentStruct, $elm$json$Json$Decode$value, $author$project$ApiSchemas$includedDecoder));
var $author$project$ApiSchemas$resource = function (decoder) {
	return A2($author$project$ApiSchemas$data, decoder, $author$project$ApiSchemas$document);
};
var $author$project$Carwow$StockDealCard$Data$getDeal = F5(
	function (origin, jwt, id, appName, msg) {
		return A5(
			$author$project$DealsServiceApi$getDeal,
			id,
			_List_fromArray(
				[
					_Utils_Tuple2(
					'include',
					A2(
						$elm$core$String$join,
						',',
						_List_fromArray(
							['supplier', 'vehicle.brand', 'vehicle.model']))),
					_Utils_Tuple2('extra_fields[suppliers]', 'delivery_only'),
					_Utils_Tuple2('extra_fields[vehicles]', 'model_review'),
					_Utils_Tuple2('app_name', appName)
				]),
			$author$project$ApiSchemas$resource($author$project$Carwow$StockDealCard$Data$dealDecoder),
			msg,
			A2($author$project$DealsServiceApi$initAuthedClient, origin, jwt));
	});
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Carwow$IntersectionObserver$intersectionObserve = _Platform_outgoingPort('intersectionObserve', $elm$json$Json$Encode$string);
var $author$project$Carwow$StockDealCard$init = function (flags) {
	var cardId = 'stock-deal-card-' + flags.ac;
	var appName = A2($elm$core$Maybe$withDefault, '', flags.az);
	return _Utils_Tuple2(
		{
			_: cardId,
			u: $author$project$Carwow$StockDealCard$NotVisible,
			aG: A5($author$project$Carwow$StockDealCard$Data$getDeal, flags.N, flags.aP, flags.ac, appName, $author$project$Carwow$StockDealCard$DealFetched),
			ba: {Y: flags.Y, ab: flags.ab, ad: flags.ad, N: flags.N, af: flags.af, ao: flags.ao === 'true', ap: flags.ap === 'true', aq: flags.aq === 'true', ar: flags.ar === 'true', as: flags.as, aw: flags.aw}
		},
		$author$project$Carwow$IntersectionObserver$intersectionObserve(cardId));
};
var $author$project$Carwow$StockDealCard$CardVisible = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $author$project$Carwow$IntersectionObserver$intersecting = _Platform_incomingPort(
	'intersecting',
	A2(
		$elm$json$Json$Decode$andThen,
		function (isIntersecting) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (elementId) {
					return $elm$json$Json$Decode$succeed(
						{bm: elementId, bB: isIntersecting});
				},
				A2($elm$json$Json$Decode$field, 'elementId', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'isIntersecting', $elm$json$Json$Decode$bool)));
var $author$project$Carwow$StockDealCard$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Carwow$IntersectionObserver$intersecting($author$project$Carwow$StockDealCard$CardVisible)
			]));
};
var $author$project$Carwow$StockDealCard$FetchingDeal = {$: 1};
var $author$project$Carwow$StockDealCard$fetchDeal = function (model) {
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{u: $author$project$Carwow$StockDealCard$FetchingDeal}),
		model.aG);
};
var $author$project$Carwow$StockDealCard$Retriable = {$: 3};
var $author$project$Carwow$StockDealCard$msgToString = function (msg) {
	switch (msg.$) {
		case 2:
			return 'RetryRequested';
		case 0:
			return 'CardVisible';
		default:
			return 'DealFetched';
	}
};
var $author$project$Carwow$Bugsnag$Internal$List = function (a) {
	return {$: 2, a: a};
};
var $author$project$Carwow$Bugsnag$Internal$String = function (a) {
	return {$: 0, a: a};
};
var $author$project$Carwow$Bugsnag$Internal$Error = $elm$core$Basics$identity;
var $author$project$Carwow$Bugsnag$addTab = F3(
	function (name, attributes, _v0) {
		var error = _v0;
		return _Utils_update(
			error,
			{
				aS: A3($elm$core$Dict$insert, name, attributes, error.aS)
			});
	});
var $author$project$Carwow$Bugsnag$Http$addContextTab = function (context) {
	return A2(
		$author$project$Carwow$Bugsnag$addTab,
		'context',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'method',
				$author$project$Carwow$Bugsnag$Internal$String(context.de)),
				_Utils_Tuple2(
				'url',
				$author$project$Carwow$Bugsnag$Internal$String(context.dZ)),
				_Utils_Tuple2(
				'headers',
				$author$project$Carwow$Bugsnag$Internal$List(context.bu))
			]));
};
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $author$project$Carwow$Bugsnag$addMessage = F2(
	function (message, _v0) {
		var error = _v0;
		return _Utils_update(
			error,
			{
				aR: A2(
					$elm$core$List$append,
					error.aR,
					_List_fromArray(
						[message]))
			});
	});
var $author$project$Carwow$Bugsnag$Internal$Int = function (a) {
	return {$: 1, a: a};
};
var $author$project$Carwow$Bugsnag$Http$addResponseTab = function (response) {
	return A2(
		$author$project$Carwow$Bugsnag$addTab,
		'response',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'status',
				$author$project$Carwow$Bugsnag$Internal$Int(response.b6)),
				_Utils_Tuple2(
				'headers',
				$author$project$Carwow$Bugsnag$Internal$List(response.bu)),
				_Utils_Tuple2(
				'body',
				$author$project$Carwow$Bugsnag$Internal$String(response.bf))
			]));
};
var $author$project$Carwow$Bugsnag$groupBy = F2(
	function (group, _v0) {
		var error = _v0;
		return _Utils_update(
			error,
			{
				aH: A2($elm$core$List$cons, group, error.aH)
			});
	});
var $author$project$Carwow$Bugsnag$newError = function (error) {
	return {cR: error, cY: $elm$core$Maybe$Nothing, aH: _List_Nil, aR: _List_Nil, aS: $elm$core$Dict$empty};
};
var $author$project$Carwow$Bugsnag$Http$newError = F2(
	function (group, error) {
		return A2(
			$author$project$Carwow$Bugsnag$groupBy,
			group,
			function () {
				switch (error.$) {
					case 0:
						var url = error.a;
						var context = error.b;
						return A2(
							$author$project$Carwow$Bugsnag$Http$addContextTab,
							context,
							A2(
								$author$project$Carwow$Bugsnag$addMessage,
								url,
								$author$project$Carwow$Bugsnag$newError('Http.BadUrl')));
					case 1:
						var context = error.a;
						return A2(
							$author$project$Carwow$Bugsnag$Http$addContextTab,
							context,
							A2(
								$author$project$Carwow$Bugsnag$addMessage,
								context.dZ,
								$author$project$Carwow$Bugsnag$newError('Http.Timeout')));
					case 2:
						var context = error.a;
						return A2(
							$author$project$Carwow$Bugsnag$Http$addContextTab,
							context,
							A2(
								$author$project$Carwow$Bugsnag$addMessage,
								context.dZ,
								$author$project$Carwow$Bugsnag$newError('Http.NetworkError')));
					case 3:
						var response = error.b;
						return A2(
							$author$project$Carwow$Bugsnag$Http$addResponseTab,
							response,
							A2(
								$author$project$Carwow$Bugsnag$Http$addContextTab,
								response.aa,
								A2(
									$author$project$Carwow$Bugsnag$addMessage,
									response.bf,
									A2(
										$author$project$Carwow$Bugsnag$addMessage,
										response.aa.dZ,
										$author$project$Carwow$Bugsnag$newError(
											'Http.BadStatus: ' + $elm$core$String$fromInt(response.b6))))));
					default:
						var errorMessage = error.a;
						var response = error.b;
						return A2(
							$author$project$Carwow$Bugsnag$Http$addResponseTab,
							response,
							A2(
								$author$project$Carwow$Bugsnag$Http$addContextTab,
								response.aa,
								A2(
									$author$project$Carwow$Bugsnag$addMessage,
									errorMessage,
									A2(
										$author$project$Carwow$Bugsnag$addMessage,
										response.aa.dZ,
										$author$project$Carwow$Bugsnag$newError('Http.BadBody')))));
				}
			}());
	});
var $author$project$Carwow$Bugsnag$bugsnagNotify = _Platform_outgoingPort('bugsnagNotify', $elm$core$Basics$identity);
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$json$Json$Encode$dict = F3(
	function (toKey, toValue, dictionary) {
		return _Json_wrap(
			A3(
				$elm$core$Dict$foldl,
				F3(
					function (key, value, obj) {
						return A3(
							_Json_addField,
							toKey(key),
							toValue(value),
							obj);
					}),
				_Json_emptyObject(0),
				dictionary));
	});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$Carwow$Bugsnag$Internal$encodeValue = function (value) {
	switch (value.$) {
		case 0:
			var string = value.a;
			return $elm$json$Json$Encode$string(string);
		case 1:
			var _int = value.a;
			return $elm$json$Json$Encode$int(_int);
		default:
			var list = value.a;
			return A3(
				$elm$json$Json$Encode$dict,
				$elm$core$Basics$identity,
				$elm$json$Json$Encode$string,
				$elm$core$Dict$fromList(list));
	}
};
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Carwow$Bugsnag$Internal$encodeValueList = A2(
	$elm$core$Basics$composeL,
	$elm$json$Json$Encode$object,
	$elm$core$List$map(
		$elm$core$Tuple$mapSecond($author$project$Carwow$Bugsnag$Internal$encodeValue)));
var $author$project$Carwow$Bugsnag$Internal$encodeError = function (_v0) {
	var error = _v0;
	var errorWithGroups = function () {
		var _v1 = error.aH;
		if (!_v1.b) {
			return error.cR;
		} else {
			return A2(
				$elm$core$String$join,
				' @ ',
				_List_fromArray(
					[
						error.cR,
						A2($elm$core$String$join, ', ', error.aH)
					]));
		}
	}();
	var groupingHash = A2($elm$core$Maybe$withDefault, errorWithGroups, error.cY);
	var message = A2(
		$elm$core$String$join,
		'\n',
		A2($elm$core$List$cons, errorWithGroups, error.aR));
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'message',
				$elm$json$Json$Encode$string(message)),
				_Utils_Tuple2(
				'groupingHash',
				$elm$json$Json$Encode$string(groupingHash)),
				_Utils_Tuple2(
				'metaData',
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $author$project$Carwow$Bugsnag$Internal$encodeValueList, error.aS))
			]));
};
var $author$project$Carwow$Bugsnag$notify = A2($elm$core$Basics$composeR, $author$project$Carwow$Bugsnag$Internal$encodeError, $author$project$Carwow$Bugsnag$bugsnagNotify);
var $author$project$Carwow$StockDealCard$handleResponse = F4(
	function (model, msg, response, onSuccess) {
		if (!response.$) {
			var data = response.a;
			return A2(onSuccess, model, data.bf);
		} else {
			var error = response.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{u: $author$project$Carwow$StockDealCard$Retriable}),
				$author$project$Carwow$Bugsnag$notify(
					A2(
						$author$project$Carwow$Bugsnag$Http$newError,
						$author$project$Carwow$StockDealCard$msgToString(msg),
						error)));
		}
	});
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Carwow$StockDealCard$stateToString = function (state) {
	switch (state.$) {
		case 0:
			return 'NotVisible';
		case 1:
			return 'FetchingDeal';
		case 2:
			return 'FetchedDeal';
		default:
			return 'Retriable';
	}
};
var $author$project$Carwow$StockDealCard$notifyUnexpectedMessage = F2(
	function (state, msg) {
		return $author$project$Carwow$Bugsnag$notify(
			A2(
				$author$project$Carwow$Bugsnag$groupBy,
				$author$project$Carwow$StockDealCard$stateToString(state),
				$author$project$Carwow$Bugsnag$newError(
					'Unexpected message: ' + $author$project$Carwow$StockDealCard$msgToString(msg))));
	});
var $author$project$Carwow$StockDealCard$onCardVisible = F2(
	function (model, intersectingInfo) {
		return (intersectingInfo.bB && _Utils_eq(intersectingInfo.bm, model._)) ? $author$project$Carwow$StockDealCard$fetchDeal(model) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Carwow$StockDealCard$FetchedDeal = function (a) {
	return {$: 2, a: a};
};
var $author$project$Carwow$StockDealCard$onDealFetched = F2(
	function (model, deal) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					u: $author$project$Carwow$StockDealCard$FetchedDeal(deal)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Carwow$StockDealCard$update = F2(
	function (msg, model) {
		var _v0 = _Utils_Tuple2(model.u, msg);
		_v0$4:
		while (true) {
			switch (_v0.b.$) {
				case 0:
					if (!_v0.a.$) {
						var _v1 = _v0.a;
						var intersectingInfo = _v0.b.a;
						return A2($author$project$Carwow$StockDealCard$onCardVisible, model, intersectingInfo);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 1:
					if (_v0.a.$ === 1) {
						var _v2 = _v0.a;
						var response = _v0.b.a;
						return A4($author$project$Carwow$StockDealCard$handleResponse, model, msg, response, $author$project$Carwow$StockDealCard$onDealFetched);
					} else {
						break _v0$4;
					}
				default:
					if (_v0.a.$ === 3) {
						var _v3 = _v0.a;
						var _v4 = _v0.b;
						return $author$project$Carwow$StockDealCard$fetchDeal(model);
					} else {
						break _v0$4;
					}
			}
		}
		return _Utils_Tuple2(
			model,
			A2($author$project$Carwow$StockDealCard$notifyUnexpectedMessage, model.u, msg));
	});
var $author$project$Carwow$StockDealCard$RetryRequested = {$: 2};
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $author$project$Carwow$StockDealCard$View$Media$Media = F2(
	function (slider, badge) {
		return {Y: badge, b4: slider};
	});
var $author$project$AutomaticTranslations$StockDealCard$brandNew = 'Brand new';
var $cuducos$elm_format_number$FormatNumber$Locales$Exact = function (a) {
	return {$: 2, a: a};
};
var $cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber = F5(
	function (original, integers, decimals, prefix, suffix) {
		return {cE: decimals, bA: integers, bK: original, al: prefix, at: suffix};
	});
var $cuducos$elm_format_number$FormatNumber$Parser$Negative = 2;
var $cuducos$elm_format_number$FormatNumber$Parser$Positive = 0;
var $cuducos$elm_format_number$FormatNumber$Parser$Zero = 1;
var $cuducos$elm_format_number$FormatNumber$Parser$classify = function (formatted) {
	var onlyZeros = A2(
		$elm$core$String$all,
		function (_char) {
			return _char === '0';
		},
		$elm$core$String$concat(
			A2(
				$elm$core$List$append,
				formatted.bA,
				$elm$core$List$singleton(formatted.cE))));
	return onlyZeros ? 1 : ((formatted.bK < 0) ? 2 : 0);
};
var $elm$core$String$filter = _String_filter;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit = F2(
	function (desiredLength, value) {
		var length = $elm$core$String$length(value);
		var missing = (_Utils_cmp(length, desiredLength) < 0) ? $elm$core$Basics$abs(desiredLength - length) : 0;
		return _Utils_ap(
			value,
			A2($elm$core$String$repeat, missing, '0'));
	});
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $cuducos$elm_format_number$FormatNumber$Parser$removeZeros = function (decimals) {
	return (A2($elm$core$String$right, 1, decimals) !== '0') ? decimals : $cuducos$elm_format_number$FormatNumber$Parser$removeZeros(
		A2($elm$core$String$dropRight, 1, decimals));
};
var $cuducos$elm_format_number$FormatNumber$Parser$getDecimals = F2(
	function (locale, digits) {
		var _v0 = locale.cE;
		switch (_v0.$) {
			case 1:
				return $cuducos$elm_format_number$FormatNumber$Parser$removeZeros(digits);
			case 2:
				return digits;
			default:
				var min = _v0.a;
				return A2($cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit, min, digits);
		}
	});
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $elm$core$String$fromFloat = _String_fromNumber;
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Basics$not = _Basics_not;
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $myrho$elm_round$Round$addSign = F2(
	function (signed, str) {
		var isNotZero = A2(
			$elm$core$List$any,
			function (c) {
				return (c !== '0') && (c !== '.');
			},
			$elm$core$String$toList(str));
		return _Utils_ap(
			(signed && isNotZero) ? '-' : '',
			str);
	});
var $elm$core$String$cons = _String_cons;
var $elm$core$Char$fromCode = _Char_fromCode;
var $myrho$elm_round$Round$increaseNum = function (_v0) {
	var head = _v0.a;
	var tail = _v0.b;
	if (head === '9') {
		var _v1 = $elm$core$String$uncons(tail);
		if (_v1.$ === 1) {
			return '01';
		} else {
			var headtail = _v1.a;
			return A2(
				$elm$core$String$cons,
				'0',
				$myrho$elm_round$Round$increaseNum(headtail));
		}
	} else {
		var c = $elm$core$Char$toCode(head);
		return ((c >= 48) && (c < 57)) ? A2(
			$elm$core$String$cons,
			$elm$core$Char$fromCode(c + 1),
			tail) : '0';
	}
};
var $elm$core$Basics$isInfinite = _Basics_isInfinite;
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $elm$core$String$reverse = _String_reverse;
var $myrho$elm_round$Round$splitComma = function (str) {
	var _v0 = A2($elm$core$String$split, '.', str);
	if (_v0.b) {
		if (_v0.b.b) {
			var before = _v0.a;
			var _v1 = _v0.b;
			var after = _v1.a;
			return _Utils_Tuple2(before, after);
		} else {
			var before = _v0.a;
			return _Utils_Tuple2(before, '0');
		}
	} else {
		return _Utils_Tuple2('0', '0');
	}
};
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $myrho$elm_round$Round$toDecimal = function (fl) {
	var _v0 = A2(
		$elm$core$String$split,
		'e',
		$elm$core$String$fromFloat(
			$elm$core$Basics$abs(fl)));
	if (_v0.b) {
		if (_v0.b.b) {
			var num = _v0.a;
			var _v1 = _v0.b;
			var exp = _v1.a;
			var e = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					A2($elm$core$String$startsWith, '+', exp) ? A2($elm$core$String$dropLeft, 1, exp) : exp));
			var _v2 = $myrho$elm_round$Round$splitComma(num);
			var before = _v2.a;
			var after = _v2.b;
			var total = _Utils_ap(before, after);
			var zeroed = (e < 0) ? A2(
				$elm$core$Maybe$withDefault,
				'0',
				A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var a = _v3.a;
						var b = _v3.b;
						return a + ('.' + b);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$mapFirst($elm$core$String$fromChar),
						$elm$core$String$uncons(
							_Utils_ap(
								A2(
									$elm$core$String$repeat,
									$elm$core$Basics$abs(e),
									'0'),
								total))))) : A3($elm$core$String$padRight, e + 1, '0', total);
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				zeroed);
		} else {
			var num = _v0.a;
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				num);
		}
	} else {
		return '';
	}
};
var $myrho$elm_round$Round$roundFun = F3(
	function (functor, s, fl) {
		if ($elm$core$Basics$isInfinite(fl) || $elm$core$Basics$isNaN(fl)) {
			return $elm$core$String$fromFloat(fl);
		} else {
			var signed = fl < 0;
			var _v0 = $myrho$elm_round$Round$splitComma(
				$myrho$elm_round$Round$toDecimal(
					$elm$core$Basics$abs(fl)));
			var before = _v0.a;
			var after = _v0.b;
			var r = $elm$core$String$length(before) + s;
			var normalized = _Utils_ap(
				A2($elm$core$String$repeat, (-r) + 1, '0'),
				A3(
					$elm$core$String$padRight,
					r,
					'0',
					_Utils_ap(before, after)));
			var totalLen = $elm$core$String$length(normalized);
			var roundDigitIndex = A2($elm$core$Basics$max, 1, r);
			var increase = A2(
				functor,
				signed,
				A3($elm$core$String$slice, roundDigitIndex, totalLen, normalized));
			var remains = A3($elm$core$String$slice, 0, roundDigitIndex, normalized);
			var num = increase ? $elm$core$String$reverse(
				A2(
					$elm$core$Maybe$withDefault,
					'1',
					A2(
						$elm$core$Maybe$map,
						$myrho$elm_round$Round$increaseNum,
						$elm$core$String$uncons(
							$elm$core$String$reverse(remains))))) : remains;
			var numLen = $elm$core$String$length(num);
			var numZeroed = (num === '0') ? num : ((s <= 0) ? _Utils_ap(
				num,
				A2(
					$elm$core$String$repeat,
					$elm$core$Basics$abs(s),
					'0')) : ((_Utils_cmp(
				s,
				$elm$core$String$length(after)) < 0) ? (A3($elm$core$String$slice, 0, numLen - s, num) + ('.' + A3($elm$core$String$slice, numLen - s, numLen, num))) : _Utils_ap(
				before + '.',
				A3($elm$core$String$padRight, s, '0', after))));
			return A2($myrho$elm_round$Round$addSign, signed, numZeroed);
		}
	});
var $myrho$elm_round$Round$round = $myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _v0 = $elm$core$String$uncons(str);
			if (_v0.$ === 1) {
				return false;
			} else {
				if ('5' === _v0.a.a) {
					if (_v0.a.b === '') {
						var _v1 = _v0.a;
						return !signed;
					} else {
						var _v2 = _v0.a;
						return true;
					}
				} else {
					var _v3 = _v0.a;
					var _int = _v3.a;
					return function (i) {
						return ((i > 53) && signed) || ((i >= 53) && (!signed));
					}(
						$elm$core$Char$toCode(_int));
				}
			}
		}));
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $cuducos$elm_format_number$FormatNumber$Parser$splitInParts = F2(
	function (locale, value) {
		var toString = function () {
			var _v1 = locale.cE;
			switch (_v1.$) {
				case 1:
					var max = _v1.a;
					return $myrho$elm_round$Round$round(max);
				case 0:
					return $elm$core$String$fromFloat;
				default:
					var exact = _v1.a;
					return $myrho$elm_round$Round$round(exact);
			}
		}();
		var asList = A2(
			$elm$core$String$split,
			'.',
			toString(value));
		var decimals = function () {
			var _v0 = $elm$core$List$tail(asList);
			if (!_v0.$) {
				var values = _v0.a;
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					$elm$core$List$head(values));
			} else {
				return '';
			}
		}();
		var integers = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(asList));
		return _Utils_Tuple2(integers, decimals);
	});
var $cuducos$elm_format_number$FormatNumber$Parser$splitByIndian = function (integers) {
	var thousand = ($elm$core$String$length(integers) > 3) ? A2($elm$core$String$right, 3, integers) : integers;
	var reversedSplitHundreds = function (value) {
		return ($elm$core$String$length(value) > 2) ? A2(
			$elm$core$List$cons,
			A2($elm$core$String$right, 2, value),
			reversedSplitHundreds(
				A2($elm$core$String$dropRight, 2, value))) : ((!$elm$core$String$length(value)) ? _List_Nil : _List_fromArray(
			[value]));
	};
	return $elm$core$List$reverse(
		A2(
			$elm$core$List$cons,
			thousand,
			reversedSplitHundreds(
				A2($elm$core$String$dropRight, 3, integers))));
};
var $cuducos$elm_format_number$FormatNumber$Parser$splitByWestern = function (integers) {
	var reversedSplitThousands = function (value) {
		return ($elm$core$String$length(value) > 3) ? A2(
			$elm$core$List$cons,
			A2($elm$core$String$right, 3, value),
			reversedSplitThousands(
				A2($elm$core$String$dropRight, 3, value))) : _List_fromArray(
			[value]);
	};
	return $elm$core$List$reverse(
		reversedSplitThousands(integers));
};
var $cuducos$elm_format_number$FormatNumber$Parser$splitIntegers = F2(
	function (system, integers) {
		if (!system) {
			return $cuducos$elm_format_number$FormatNumber$Parser$splitByWestern(
				A2($elm$core$String$filter, $elm$core$Char$isDigit, integers));
		} else {
			return $cuducos$elm_format_number$FormatNumber$Parser$splitByIndian(
				A2($elm$core$String$filter, $elm$core$Char$isDigit, integers));
		}
	});
var $cuducos$elm_format_number$FormatNumber$Parser$parse = F2(
	function (locale, original) {
		var parts = A2($cuducos$elm_format_number$FormatNumber$Parser$splitInParts, locale, original);
		var integers = A2(
			$cuducos$elm_format_number$FormatNumber$Parser$splitIntegers,
			locale.au,
			A2($elm$core$String$filter, $elm$core$Char$isDigit, parts.a));
		var decimals = A2($cuducos$elm_format_number$FormatNumber$Parser$getDecimals, locale, parts.b);
		var partial = A5($cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber, original, integers, decimals, '', '');
		var _v0 = $cuducos$elm_format_number$FormatNumber$Parser$classify(partial);
		switch (_v0) {
			case 2:
				return _Utils_update(
					partial,
					{al: locale.aW, at: locale.aX});
			case 0:
				return _Utils_update(
					partial,
					{al: locale.bO, at: locale.bP});
			default:
				return _Utils_update(
					partial,
					{al: locale.ci, at: locale.cj});
		}
	});
var $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals = F2(
	function (locale, decimals) {
		return (decimals === '') ? '' : _Utils_ap(locale.cD, decimals);
	});
var $cuducos$elm_format_number$FormatNumber$Stringfy$stringfy = F2(
	function (locale, formatted) {
		var stringfyDecimals = $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals(locale);
		var integers = A2($elm$core$String$join, locale.dM, formatted.bA);
		var decimals = stringfyDecimals(formatted.cE);
		return $elm$core$String$concat(
			_List_fromArray(
				[formatted.al, integers, decimals, formatted.at]));
	});
var $cuducos$elm_format_number$FormatNumber$format = F2(
	function (locale, number_) {
		return A2(
			$cuducos$elm_format_number$FormatNumber$Stringfy$stringfy,
			locale,
			A2($cuducos$elm_format_number$FormatNumber$Parser$parse, locale, number_));
	});
var $cuducos$elm_format_number$FormatNumber$Locales$Min = function (a) {
	return {$: 0, a: a};
};
var $cuducos$elm_format_number$FormatNumber$Locales$Western = 0;
var $cuducos$elm_format_number$FormatNumber$Locales$base = {
	cD: '.',
	cE: $cuducos$elm_format_number$FormatNumber$Locales$Min(0),
	aW: '−',
	aX: '',
	bO: '',
	bP: '',
	au: 0,
	dM: '',
	ci: '',
	cj: ''
};
var $cuducos$elm_format_number$FormatNumber$Locales$spanishLocale = _Utils_update(
	$cuducos$elm_format_number$FormatNumber$Locales$base,
	{
		cD: ',',
		cE: $cuducos$elm_format_number$FormatNumber$Locales$Exact(3),
		dM: '.'
	});
var $author$project$ThemeTranslations$Numbers$formatNumber = F2(
	function (x, precision) {
		return A2(
			$cuducos$elm_format_number$FormatNumber$format,
			_Utils_update(
				$cuducos$elm_format_number$FormatNumber$Locales$spanishLocale,
				{
					cE: $cuducos$elm_format_number$FormatNumber$Locales$Exact(precision)
				}),
			x);
	});
var $author$project$AutomaticTranslations$Search$Filters$miles = 'miles';
var $author$project$Carwow$StockDealCard$ViewModel$Features$mapDistanceTravelled = function (distanceTravelled) {
	var distance = A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.d_;
			},
			distanceTravelled));
	return (!distance) ? $author$project$AutomaticTranslations$StockDealCard$brandNew : ((distance < 100) ? ('< 100 ' + $author$project$AutomaticTranslations$Search$Filters$miles) : (A2($author$project$ThemeTranslations$Numbers$formatNumber, distance, 0) + (' ' + $author$project$AutomaticTranslations$Search$Filters$miles)));
};
var $author$project$ApiSchemas$Vehicle$ValueUnit$findByUnit = function (unit) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$filter(
			function (valueUnit) {
				return _Utils_eq(valueUnit.dX, unit);
			}),
		$elm$core$List$head);
};
var $author$project$ApiSchemas$Vehicle$findByUnit = $author$project$ApiSchemas$Vehicle$ValueUnit$findByUnit;
var $author$project$AutomaticTranslations$StockDealCard$Cc$none = '0 litres';
var $author$project$AutomaticTranslations$StockDealCard$Cc$plural = 'litres';
var $author$project$AutomaticTranslations$StockDealCard$Cc$singular = '1 litre';
var $author$project$Carwow$StockDealCard$ViewModel$Features$formatEngineSize = function (litres) {
	return (!litres) ? $author$project$AutomaticTranslations$StockDealCard$Cc$none : ((litres === 1) ? $author$project$AutomaticTranslations$StockDealCard$Cc$singular : (A2($author$project$ThemeTranslations$Numbers$formatNumber, litres, 1) + (' ' + $author$project$AutomaticTranslations$StockDealCard$Cc$plural)));
};
var $author$project$Carwow$StockDealCard$ViewModel$Features$mapEngineSize = function (engine) {
	return A2(
		$elm$core$Maybe$map,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.d_;
			},
			$author$project$Carwow$StockDealCard$ViewModel$Features$formatEngineSize),
		A2($author$project$ApiSchemas$Vehicle$findByUnit, $author$project$ApiSchemas$Vehicle$LITRE, engine.dC));
};
var $author$project$AutomaticTranslations$StockDealCard$power = F2(
	function (power_kw, power_ps) {
		return '' + (power_kw + (' kW (' + (power_ps + ' PS)')));
	});
var $author$project$Carwow$StockDealCard$ViewModel$Features$mapEnginePowerKw = function (engine) {
	var maybePS = A2($author$project$ApiSchemas$Vehicle$findByUnit, $author$project$ApiSchemas$Vehicle$PS, engine.dn);
	var maybeKW = A2($author$project$ApiSchemas$Vehicle$findByUnit, $author$project$ApiSchemas$Vehicle$KW, engine.dn);
	var _v0 = _Utils_Tuple2(maybeKW, maybePS);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var kw = _v0.a.a;
		var ps = _v0.b.a;
		return $elm$core$Maybe$Just(
			A2(
				$author$project$AutomaticTranslations$StockDealCard$power,
				$elm$core$String$fromInt(kw.d_),
				$elm$core$String$fromInt(ps.d_)));
	} else {
		return $author$project$Carwow$StockDealCard$ViewModel$Features$mapEngineSize(engine);
	}
};
var $author$project$Carwow$StockDealCard$ViewModel$Features$mapEngine = function (showPowerKw) {
	return showPowerKw ? $author$project$Carwow$StockDealCard$ViewModel$Features$mapEnginePowerKw : $author$project$Carwow$StockDealCard$ViewModel$Features$mapEngineSize;
};
var $author$project$AutomaticTranslations$StockDealCard$Vehicles$FuelCategory$diesel = 'Diesel';
var $author$project$AutomaticTranslations$StockDealCard$Vehicles$FuelCategory$electric = 'Electric';
var $author$project$AutomaticTranslations$StockDealCard$Vehicles$FuelCategory$hybrid = 'Hybrid';
var $author$project$AutomaticTranslations$StockDealCard$Vehicles$FuelCategory$petrol = 'Petrol';
var $author$project$Carwow$StockDealCard$ViewModel$Features$mapFuel = function (fuel) {
	var _v0 = fuel.cr;
	switch (_v0.$) {
		case 0:
			return $author$project$AutomaticTranslations$StockDealCard$Vehicles$FuelCategory$diesel;
		case 1:
			return $author$project$AutomaticTranslations$StockDealCard$Vehicles$FuelCategory$electric;
		case 2:
			return $author$project$AutomaticTranslations$StockDealCard$Vehicles$FuelCategory$hybrid;
		case 4:
			return $author$project$AutomaticTranslations$StockDealCard$Vehicles$FuelCategory$petrol;
		case 3:
			return 'Hydrogen';
		default:
			var unknown = _v0.a;
			return unknown;
	}
};
var $author$project$AutomaticTranslations$StockDealCard$Vehicles$TransmissionCategory$automatic = 'Automatic';
var $author$project$AutomaticTranslations$StockDealCard$Vehicles$TransmissionCategory$manual = 'Manual';
var $author$project$Carwow$StockDealCard$ViewModel$Features$mapTransmission = function (fuel) {
	var _v0 = fuel.cr;
	switch (_v0.$) {
		case 0:
			return $author$project$AutomaticTranslations$StockDealCard$Vehicles$TransmissionCategory$manual;
		case 1:
			return $author$project$AutomaticTranslations$StockDealCard$Vehicles$TransmissionCategory$automatic;
		default:
			var unknown = _v0.a;
			return unknown;
	}
};
var $author$project$Carwow$StockDealCard$ViewModel$Features$map = F2(
	function (flags, vehicle) {
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					$author$project$Carwow$StockDealCard$ViewModel$Features$mapDistanceTravelled(vehicle.cK)),
					A2($author$project$Carwow$StockDealCard$ViewModel$Features$mapEngine, flags.aq, vehicle.cQ),
					$elm$core$Maybe$Just(
					$author$project$Carwow$StockDealCard$ViewModel$Features$mapTransmission(vehicle.dV)),
					$elm$core$Maybe$Just(
					$author$project$Carwow$StockDealCard$ViewModel$Features$mapFuel(vehicle.cV))
				]));
	});
var $author$project$Carwow$StockDealCard$ViewModel$PriceConfidence$FairPrice = {$: 1};
var $author$project$Carwow$StockDealCard$ViewModel$PriceConfidence$GoodPrice = {$: 0};
var $author$project$Carwow$StockDealCard$ViewModel$PriceConfidence$OverPriced = {$: 2};
var $author$project$Carwow$StockDealCard$ViewModel$PriceConfidence$calculatePriceConfidence = F2(
	function (price, market) {
		var ratio = price / market;
		return (ratio < 1) ? $author$project$Carwow$StockDealCard$ViewModel$PriceConfidence$GoodPrice : ((ratio <= 1.08) ? $author$project$Carwow$StockDealCard$ViewModel$PriceConfidence$FairPrice : $author$project$Carwow$StockDealCard$ViewModel$PriceConfidence$OverPriced);
	});
var $author$project$Carwow$StockDealCard$ViewModel$PriceConfidence$Saving = function (a) {
	return {$: 3, a: a};
};
var $author$project$Carwow$StockDealCard$ViewModel$PriceConfidence$calculateSaving = F2(
	function (rrp, price) {
		var saving = rrp - price;
		return (saving > 0) ? $elm$core$Maybe$Just(
			$author$project$Carwow$StockDealCard$ViewModel$PriceConfidence$Saving(saving)) : $elm$core$Maybe$Nothing;
	});
var $author$project$ApiSchemas$Vehicle$isUsed = function (state_) {
	switch (state_.$) {
		case 4:
			return true;
		case 3:
			return true;
		default:
			return false;
	}
};
var $author$project$Carwow$StockDealCard$ViewModel$PriceConfidence$map = F2(
	function (flags, deal) {
		var _v0 = deal.dq;
		if (!_v0.$) {
			var price = _v0.a;
			return $author$project$ApiSchemas$Vehicle$isUsed(deal.d$.dG) ? (flags.ar ? A2(
				$elm$core$Maybe$map,
				$author$project$Carwow$StockDealCard$ViewModel$PriceConfidence$calculatePriceConfidence(price.d_),
				deal.d$.dp.dc) : $elm$core$Maybe$Nothing) : A2($author$project$Carwow$StockDealCard$ViewModel$PriceConfidence$calculateSaving, deal.d$.dp.dz, price.d_);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Carwow$StockDealCard$ViewModel$mapAskForLeasingPrice = F2(
	function (flags, vehicle) {
		return flags.ao && (!$author$project$ApiSchemas$Vehicle$isUsed(vehicle.dG));
	});
var $elm$core$Basics$atan2 = _Basics_atan2;
var $elm$core$Basics$cos = _Basics_cos;
var $fbonetti$elm_geodesy$Geodesy$earthRadius = function (unit) {
	switch (unit) {
		case 0:
			return 6371.0;
		case 1:
			return 6371000;
		case 2:
			return 3958.8;
		default:
			return 5280 * 3958.8;
	}
};
var $elm$core$Basics$sin = _Basics_sin;
var $elm$core$Basics$sqrt = _Basics_sqrt;
var $elm$core$Basics$pi = _Basics_pi;
var $fbonetti$elm_geodesy$Geodesy$toRadians = function (num) {
	return (num * $elm$core$Basics$pi) / 180;
};
var $fbonetti$elm_geodesy$Geodesy$distance = F3(
	function (_v0, _v1, unit) {
		var lat1 = _v0.a;
		var lon1 = _v0.b;
		var lat2 = _v1.a;
		var lon2 = _v1.b;
		var radius = $fbonetti$elm_geodesy$Geodesy$earthRadius(unit);
		var lon2_ = $fbonetti$elm_geodesy$Geodesy$toRadians(lon2);
		var lon1_ = $fbonetti$elm_geodesy$Geodesy$toRadians(lon1);
		var lat2_ = $fbonetti$elm_geodesy$Geodesy$toRadians(lat2);
		var lat1_ = $fbonetti$elm_geodesy$Geodesy$toRadians(lat1);
		var deltaLon = lon2_ - lon1_;
		var deltaLat = lat2_ - lat1_;
		var a = ($elm$core$Basics$sin(deltaLat / 2) * $elm$core$Basics$sin(deltaLat / 2)) + ((($elm$core$Basics$cos(lat1_) * $elm$core$Basics$cos(lat2_)) * $elm$core$Basics$sin(deltaLon / 2)) * $elm$core$Basics$sin(deltaLon / 2));
		var c = 2 * A2(
			$elm$core$Basics$atan2,
			$elm$core$Basics$sqrt(a),
			$elm$core$Basics$sqrt(1 - a));
		return radius * c;
	});
var $fbonetti$elm_geodesy$Geodesy$Kilometers = 0;
var $author$project$ThemeTranslations$Units$geodesy = 0;
var $author$project$Carwow$StockDealCard$ViewModel$mapDistance = F3(
	function (hideDistance, user, supplier) {
		return hideDistance ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$elm$core$Basics$ceiling(
				A3(
					$fbonetti$elm_geodesy$Geodesy$distance,
					user,
					_Utils_Tuple2(supplier.c8, supplier.db),
					$author$project$ThemeTranslations$Units$geodesy)));
	});
var $author$project$Carwow$StockDealCard$ViewModel$imageUrl = F3(
	function (angle, vehicleId, flags) {
		return $elm$core$String$concat(
			_List_fromArray(
				[flags.N, '/image?filter[angle]=', angle, '&filter[vehicle_id]=', vehicleId, '&filter[partner]=', flags.as]));
	});
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $author$project$Carwow$StockDealCard$ViewModel$noCustomImages = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map(
		function ($) {
			return $.c2;
		}),
	$elm$core$List$all(
		$elm$core$Basics$neq($author$project$ApiSchemas$Vehicle$Image$Custom)));
var $author$project$Carwow$StockDealCard$ViewModel$mapMediaSlider = F2(
	function (vehicle, flags) {
		if ($author$project$Carwow$StockDealCard$ViewModel$noCustomImages(vehicle.c3)) {
			var imageAngles = function () {
				var _v0 = flags.as;
				switch (_v0) {
					case 'carwow':
						return _List_fromArray(
							['side_left', 'front', 'rear']);
					case 'autoexpress':
						return _List_fromArray(
							['front_left', 'side_left', 'rear']);
					default:
						return _List_fromArray(
							['side_left', 'front', 'rear']);
				}
			}();
			var images = A2(
				$elm$core$List$map,
				function (angle) {
					return A3($author$project$Carwow$StockDealCard$ViewModel$imageUrl, angle, vehicle.c1, flags);
				},
				imageAngles);
			return {bn: false, bt: true, c3: images};
		} else {
			return {
				bn: false,
				bt: false,
				c3: A2(
					$elm$core$List$map,
					function ($) {
						return $.dZ;
					},
					vehicle.c3)
			};
		}
	});
var $author$project$Carwow$StockDealCard$ViewModel$vehicleYear = $elm$core$Maybe$map(
	$elm$core$String$left(4));
var $author$project$Carwow$StockDealCard$ViewModel$mapSubTitle = function (vehicle) {
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$author$project$Carwow$StockDealCard$ViewModel$vehicleYear(vehicle.dv),
					$elm$core$Maybe$Just(vehicle.cp)
				])));
};
var $author$project$Carwow$StockDealCard$ViewModel$mapTitle = function (_v0) {
	var modelReview = _v0.dg;
	var trimName = _v0.dW;
	return A2(
		$elm$core$String$join,
		' ',
		_List_fromArray(
			[modelReview.di, trimName]));
};
var $author$project$Carwow$StockDealCard$ViewModel$mapDeal = F2(
	function (flags, deal) {
		return {
			cu: {ab: flags.ab, ad: flags.ad},
			ad: flags.ad,
			cF: deal.dL.cF,
			cH: deal.d$.cG.c1,
			cJ: A3($author$project$Carwow$StockDealCard$ViewModel$mapDistance, flags.af, flags.aw, deal.dL.da),
			cU: A2($author$project$Carwow$StockDealCard$ViewModel$Features$map, flags, deal.d$),
			dd: A2(
				$author$project$Carwow$StockDealCard$View$Media$Media,
				A2($author$project$Carwow$StockDealCard$ViewModel$mapMediaSlider, deal.d$, flags),
				flags.Y),
			dr: {
				co: A2($author$project$Carwow$StockDealCard$ViewModel$mapAskForLeasingPrice, flags, deal.d$),
				cC: deal.dq,
				$7: A2($author$project$Carwow$StockDealCard$ViewModel$PriceConfidence$map, flags, deal)
			},
			dB: flags.ap,
			dI: $author$project$Carwow$StockDealCard$ViewModel$mapSubTitle(deal.d$),
			dO: $author$project$Carwow$StockDealCard$ViewModel$mapTitle(deal.d$)
		};
	});
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$Carwow$Theme$Card$Config = $elm$core$Basics$identity;
var $author$project$Carwow$Theme$Card$Default = 0;
var $author$project$Carwow$Theme$Card$defaultConfig = {Z: 0};
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$div = _VirtualDom_node('div');
var $author$project$Carwow$Theme$Card$section = function (body) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('card-generic__section')
			]),
		body);
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Carwow$StockDealCard$View$Media$badge = function (label) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('badge-stock__sale')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('badge badge-notification')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					]))
			]));
};
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$use = $elm$svg$Svg$trustedNode('use');
var $elm$svg$Svg$Attributes$version = _VirtualDom_attribute('version');
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $elm$svg$Svg$Attributes$xlinkHref = function (value) {
	return A3(
		_VirtualDom_attributeNS,
		'http://www.w3.org/1999/xlink',
		'xlink:href',
		_VirtualDom_noJavaScriptUri(value));
};
var $author$project$Carwow$Theme$Svgs$iconWithExtraClass = F3(
	function (iconName, iconProperties, extraClass) {
		var sizeClass = ' inline-icon--' + iconProperties.dC;
		var colourClass = ' inline-icon--' + iconProperties.cw;
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$version('1.1'),
					$elm$svg$Svg$Attributes$class('inline-icon' + (sizeClass + (colourClass + (' ' + extraClass)))),
					$elm$svg$Svg$Attributes$viewBox('0 0 24 24')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$use,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$xlinkHref('#sprite_icon/' + iconName)
						]),
					_List_Nil)
				]));
	});
var $author$project$Carwow$Theme$Svgs$icon = F2(
	function (iconName, iconProperties) {
		return A3($author$project$Carwow$Theme$Svgs$iconWithExtraClass, iconName, iconProperties, '');
	});
var $author$project$Carwow$StockDealCard$View$Media$placeholder = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('stock-car-search-results-card__media-placeholder')
		]),
	_List_fromArray(
		[
			A2(
			$author$project$Carwow$Theme$Svgs$icon,
			'car_sideview',
			{cw: 'light-grey', dC: 'x-large'})
		]));
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $elm$json$Json$Encode$bool = _Json_wrap;
var $author$project$Carwow$StockDealCard$View$Media$itemEncoder = function (url) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'img',
				$elm$json$Json$Encode$string(url)),
				_Utils_Tuple2(
				'video',
				$elm$json$Json$Encode$bool(false))
			]));
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Carwow$StockDealCard$View$Media$items = function (urls) {
	return A2(
		$elm$json$Json$Encode$encode,
		0,
		A2($elm$json$Json$Encode$list, $author$project$Carwow$StockDealCard$View$Media$itemEncoder, urls));
};
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $author$project$Carwow$StockDealCard$View$Media$slider = F2(
	function (model, dealsPath) {
		var tracking = A2(
			$elm$json$Json$Encode$encode,
			0,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'interaction_element',
						$elm$json$Json$Encode$string('Image')),
						_Utils_Tuple2(
						'interaction_section',
						$elm$json$Json$Encode$string('Car card'))
					])));
		return A3(
			$elm$html$Html$node,
			'carwow-media-slider',
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('media-slider', true),
							_Utils_Tuple2('media-slider--empty', model.bn),
							_Utils_Tuple2('media-slider--generic-images', model.bt)
						])),
					A2(
					$elm$html$Html$Attributes$attribute,
					'items',
					$author$project$Carwow$StockDealCard$View$Media$items(model.c3)),
					A2($elm$html$Html$Attributes$attribute, 'link_to', dealsPath),
					A2($elm$html$Html$Attributes$attribute, 'link_to_tracking', tracking)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('media-slider__nav media-slider__nav--hidden'),
							A2($elm$html$Html$Attributes$attribute, 'data-role', 'media-slider__nav')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('media-slider__arrow media-slider__prev'),
									A2($elm$html$Html$Attributes$attribute, 'data-role', 'media-slider__prev')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Carwow$Theme$Svgs$icon,
									'caret_left',
									{cw: 'white', dC: 'small'})
								])),
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('media-slider__arrow media-slider__next'),
									A2($elm$html$Html$Attributes$attribute, 'data-role', 'media-slider__next')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Carwow$Theme$Svgs$icon,
									'caret_right',
									{cw: 'white', dC: 'small'})
								]))
						]))
				]));
	});
var $author$project$Carwow$StockDealCard$View$Media$view = F2(
	function (model, dealsPath) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just($author$project$Carwow$StockDealCard$View$Media$placeholder),
						$elm$core$Maybe$Just(
						A2($author$project$Carwow$StockDealCard$View$Media$slider, model.b4, dealsPath)),
						A2($elm$core$Maybe$map, $author$project$Carwow$StockDealCard$View$Media$badge, model.Y)
					])));
	});
var $author$project$Carwow$Theme$Card$Neutral = 2;
var $author$project$Carwow$Theme$Card$Valid = 1;
var $elm$html$Html$article = _VirtualDom_node('article');
var $author$project$Carwow$Theme$Card$view = F3(
	function (_v0, media, body) {
		var borderStyle = _v0.Z;
		return A2(
			$elm$html$Html$article,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('card-generic'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('card-generic--valid', borderStyle === 1),
							_Utils_Tuple2('card-generic--neutral', borderStyle === 2)
						]))
				]),
			_List_fromArray(
				[
					media,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('card-generic__body')
						]),
					body)
				]));
	});
var $elm$html$Html$a = _VirtualDom_node('a');
var $author$project$Carwow$StockDealCard$View$DealCard$dataAttributes = $elm$core$List$map(
	function (attr) {
		return A2($elm$html$Html$Attributes$attribute, 'data-' + attr.di, attr.d_);
	});
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$AutomaticTranslations$StockDealCard$viewDeals = 'View deal';
var $author$project$Carwow$StockDealCard$View$DealCard$viewClickToAction = function (cta) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('card-generic__ctas')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(cta.ad),
							$elm$html$Html$Attributes$target('_blank'),
							$elm$html$Html$Attributes$class('btn btn--bold btn-full-width ')
						]),
					$author$project$Carwow$StockDealCard$View$DealCard$dataAttributes(cta.ab)),
				_List_fromArray(
					[
						$elm$html$Html$text($author$project$AutomaticTranslations$StockDealCard$viewDeals)
					]))
			]));
};
var $author$project$AutomaticTranslations$StockDealCard$deliveryOnly = 'Nationwide availability';
var $author$project$AutomaticTranslations$ProductListing$ProductDistance$distanceAway = function (distance) {
	return 'El coche está a una distancia de ' + (distance + '');
};
var $author$project$AutomaticTranslations$ProductListing$ProductDistance$distanceMeasure = function (count) {
	switch (count) {
		case 0:
			return '' + ($elm$core$String$fromInt(count) + ' kilómetros');
		case 1:
			return '1 kilómetro';
		default:
			return '' + ($elm$core$String$fromInt(count) + ' kilómetros');
	}
};
var $author$project$Carwow$StockDealCard$View$DealCard$formatDistanceAway = A2($elm$core$Basics$composeR, $author$project$AutomaticTranslations$ProductListing$ProductDistance$distanceMeasure, $author$project$AutomaticTranslations$ProductListing$ProductDistance$distanceAway);
var $author$project$Carwow$StockDealCard$View$DealCard$viewDistance = F2(
	function (distance, deliveryOnly) {
		if (deliveryOnly) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('card-generic-offer-details__location')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text($author$project$AutomaticTranslations$StockDealCard$deliveryOnly)
					]));
		} else {
			if (!distance.$) {
				var calculatedDistance = distance.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('card-generic__illustrated-content card-generic-offer-details__location')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('card-generic-illustrated-content__illustration')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Carwow$Theme$Svgs$icon,
									'location',
									{cw: 'dark-grey', dC: 'x-small'})
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('card-generic-illustrated-content__text')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Carwow$StockDealCard$View$DealCard$formatDistanceAway(calculatedDistance))
								]))
						]));
			} else {
				return $elm$html$Html$text('');
			}
		}
	});
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$Carwow$StockDealCard$View$DealCard$viewEfficiency = F2(
	function (showEnvkvEmissions, derivativeVersionId) {
		var turboFrameId = 'envkv-emissions-' + derivativeVersionId;
		var turboFrameSrcUrl = '/de_emissions_data?derivative_version_id=' + (derivativeVersionId + ('&turbo_frame_id=' + turboFrameId));
		return showEnvkvEmissions ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('card-generic__envkv-emissions')
				]),
			_List_fromArray(
				[
					A3(
					$elm$html$Html$node,
					'turbo-frame',
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id(turboFrameId),
							A2($elm$html$Html$Attributes$attribute, 'src', turboFrameSrcUrl),
							A2($elm$html$Html$Attributes$attribute, 'loading', 'lazy')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('loading-placeholder-text'),
									A2($elm$html$Html$Attributes$style, 'width', '100%'),
									A2($elm$html$Html$Attributes$style, 'height', '28px')
								]),
							_List_Nil)
						]))
				])) : $elm$html$Html$text('');
	});
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $elm$html$Html$li = _VirtualDom_node('li');
var $author$project$Carwow$StockDealCard$View$DealCard$nbsp = $elm$core$String$fromChar('\u00A0');
var $author$project$Carwow$StockDealCard$View$DealCard$viewFeature = function (feature) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('card-generic-features__list-item')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				_Utils_ap(feature, $author$project$Carwow$StockDealCard$View$DealCard$nbsp))
			]));
};
var $author$project$Carwow$StockDealCard$View$DealCard$viewFeatures = function (features) {
	return A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('card-generic__features')
			]),
		A2($elm$core$List$map, $author$project$Carwow$StockDealCard$View$DealCard$viewFeature, features));
};
var $author$project$AutomaticTranslations$StockDealCard$FinanceOptions$cash = 'Cash';
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$html$Html$td = _VirtualDom_node('td');
var $elm$html$Html$th = _VirtualDom_node('th');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $author$project$AutomaticTranslations$StockDealCard$askForPrice = 'Ask for price';
var $author$project$AutomaticTranslations$StockDealCard$FinanceOptions$monthly = 'Monthly';
var $author$project$Carwow$StockDealCard$View$DealCard$viewAskForLeasingPrice = function (askForLeasingPrice) {
	return askForLeasingPrice ? _Utils_Tuple2(
		A2(
			$elm$html$Html$th,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text($author$project$AutomaticTranslations$StockDealCard$FinanceOptions$monthly)
				])),
		A2(
			$elm$html$Html$td,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text($author$project$AutomaticTranslations$StockDealCard$askForPrice)
				]))) : _Utils_Tuple2(
		$elm$html$Html$text(''),
		$elm$html$Html$text(''));
};
var $author$project$AutomaticTranslations$StockDealCard$carwowSaving = function (discount) {
	return 'saving ' + (discount + ' off RRP');
};
var $author$project$AutomaticTranslations$Number$Currency$Format$delimiter = '.';
var $author$project$AutomaticTranslations$Number$Currency$Format$format = '%n %u';
var $author$project$AutomaticTranslations$Number$Currency$Format$precision = '0';
var $author$project$AutomaticTranslations$Number$Currency$Format$separator = ',';
var $author$project$AutomaticTranslations$Number$Currency$Format$significant = '';
var $author$project$AutomaticTranslations$Number$Currency$Format$stripInsignificantZeros = '';
var $author$project$AutomaticTranslations$Number$Currency$Format$unit = '€';
var $author$project$Carwow$I18n$Currency$defaultConfig = {
	aC: $author$project$AutomaticTranslations$Number$Currency$Format$delimiter,
	aE: $author$project$AutomaticTranslations$Number$Currency$Format$format,
	aZ: A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$String$toInt($author$project$AutomaticTranslations$Number$Currency$Format$precision)),
	a0: $author$project$AutomaticTranslations$Number$Currency$Format$separator,
	b3: $author$project$AutomaticTranslations$Number$Currency$Format$significant,
	b8: $author$project$AutomaticTranslations$Number$Currency$Format$stripInsignificantZeros,
	dX: $author$project$AutomaticTranslations$Number$Currency$Format$unit
};
var $cuducos$elm_format_number$FormatNumber$Locales$usLocale = _Utils_update(
	$cuducos$elm_format_number$FormatNumber$Locales$base,
	{
		cE: $cuducos$elm_format_number$FormatNumber$Locales$Exact(2),
		dM: ','
	});
var $author$project$Carwow$I18n$Currency$defaultLocale = $cuducos$elm_format_number$FormatNumber$Locales$usLocale;
var $author$project$Carwow$I18n$Currency$configToLocale = function (config) {
	return _Utils_update(
		$author$project$Carwow$I18n$Currency$defaultLocale,
		{
			cD: config.a0,
			cE: $cuducos$elm_format_number$FormatNumber$Locales$Exact(config.aZ),
			dM: config.aC
		});
};
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $author$project$Carwow$I18n$Currency$format = F3(
	function (valueToFloat, config, value) {
		var formattedValue = A2(
			$cuducos$elm_format_number$FormatNumber$format,
			$author$project$Carwow$I18n$Currency$configToLocale(config),
			valueToFloat(value));
		return A3(
			$elm$core$String$replace,
			'%n',
			formattedValue,
			A3($elm$core$String$replace, '%u', config.dX, config.aE));
	});
var $author$project$Carwow$I18n$Currency$formatFloatWithConfig = $author$project$Carwow$I18n$Currency$format($elm$core$Basics$identity);
var $author$project$Carwow$I18n$Currency$formatFloat = $author$project$Carwow$I18n$Currency$formatFloatWithConfig($author$project$Carwow$I18n$Currency$defaultConfig);
var $author$project$AutomaticTranslations$StockDealCard$CarValuation$Indicators$Fair$label = 'Fair price';
var $author$project$AutomaticTranslations$StockDealCard$CarValuation$Indicators$Good$label = 'Good price';
var $author$project$AutomaticTranslations$StockDealCard$CarValuation$Indicators$Overpriced$label = 'Overpriced';
var $author$project$Carwow$StockDealCard$View$DealCard$viewPriceConfidence = function (priceConfidence) {
	if (!priceConfidence.$) {
		switch (priceConfidence.a.$) {
			case 0:
				var _v1 = priceConfidence.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('price-indicator--positive'),
							$elm$html$Html$Attributes$class('price-indicator')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text($author$project$AutomaticTranslations$StockDealCard$CarValuation$Indicators$Good$label)
						]));
			case 1:
				var _v2 = priceConfidence.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('price-indicator--neutral'),
							$elm$html$Html$Attributes$class('price-indicator')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text($author$project$AutomaticTranslations$StockDealCard$CarValuation$Indicators$Fair$label)
						]));
			case 2:
				var _v3 = priceConfidence.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('price-indicator--negative'),
							$elm$html$Html$Attributes$class('price-indicator')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text($author$project$AutomaticTranslations$StockDealCard$CarValuation$Indicators$Overpriced$label)
						]));
			default:
				var saving = priceConfidence.a.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('card-generic__savings')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$AutomaticTranslations$StockDealCard$carwowSaving(
								$author$project$Carwow$I18n$Currency$formatFloat(saving)))
						]));
		}
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Carwow$StockDealCard$View$DealCard$viewPricing = function (pricing) {
	if (!pricing.$) {
		var price = pricing.a;
		return $author$project$Carwow$I18n$Currency$formatFloat(price.d_);
	} else {
		return $author$project$AutomaticTranslations$StockDealCard$askForPrice;
	}
};
var $author$project$Carwow$StockDealCard$View$DealCard$viewPricingTable = function (pricingTable) {
	var _v0 = $author$project$Carwow$StockDealCard$View$DealCard$viewAskForLeasingPrice(pricingTable.co);
	var askForLeasingPriceHeader = _v0.a;
	var askForLeasingPriceText = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('card-generic__pricing-table')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text($author$project$AutomaticTranslations$StockDealCard$FinanceOptions$cash)
											])),
										askForLeasingPriceHeader
									])),
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('card-generic__pricing')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Carwow$StockDealCard$View$DealCard$viewPricing(pricingTable.cC))
													]))
											])),
										askForLeasingPriceText
									])),
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Carwow$StockDealCard$View$DealCard$viewPriceConfidence(pricingTable.$7)
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Carwow$StockDealCard$View$DealCard$viewSubTitle = function (subTitle) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('card-generic__sub-title')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(subTitle)
			]));
};
var $author$project$Carwow$StockDealCard$View$DealCard$viewTitle = function (title) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('card-generic__title card-generic__title')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(title)
			]));
};
var $author$project$Carwow$StockDealCard$View$DealCard$view = function (model) {
	return A3(
		$author$project$Carwow$Theme$Card$view,
		$author$project$Carwow$Theme$Card$defaultConfig,
		A2($author$project$Carwow$StockDealCard$View$Media$view, model.dd, model.ad),
		_List_fromArray(
			[
				$author$project$Carwow$Theme$Card$section(
				_List_fromArray(
					[
						$author$project$Carwow$StockDealCard$View$DealCard$viewSubTitle(model.dI),
						$author$project$Carwow$StockDealCard$View$DealCard$viewTitle(model.dO),
						$author$project$Carwow$StockDealCard$View$DealCard$viewFeatures(model.cU),
						A2($author$project$Carwow$StockDealCard$View$DealCard$viewEfficiency, model.dB, model.cH),
						A2($author$project$Carwow$StockDealCard$View$DealCard$viewDistance, model.cJ, model.cF)
					])),
				$author$project$Carwow$Theme$Card$section(
				_List_fromArray(
					[
						$author$project$Carwow$StockDealCard$View$DealCard$viewPricingTable(model.dr),
						$author$project$Carwow$StockDealCard$View$DealCard$viewClickToAction(model.cu)
					]))
			]));
};
var $author$project$Carwow$StockDealCard$View$PlaceholderCard$view = A2(
	$elm$html$Html$article,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('card-generic')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('card-generic__media-container card-generic__placeholder card-generic-placeholder__animation')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('card-generic__body')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('card-generic__section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('card-generic__heading')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('card-generic-placeholder__animation'),
											A2($elm$html$Html$Attributes$attribute, 'style', 'height: 20px; margin-bottom: 4px')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('card-generic-placeholder__background-masker'),
													A2($elm$html$Html$Attributes$attribute, 'style', 'left: 30%; right: 0; height: 20px')
												]),
											_List_Nil)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('card-generic__title')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('card-generic-placeholder__animation'),
											A2($elm$html$Html$Attributes$attribute, 'style', 'height: 20px; margin-bottom: 0')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('card-generic-placeholder__background-masker'),
													A2($elm$html$Html$Attributes$attribute, 'style', 'left: 50%; right: 0; height: 20px')
												]),
											_List_Nil)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('card-generic__features')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('card-generic-placeholder__animation'),
											A2($elm$html$Html$Attributes$attribute, 'style', 'height: 20px; margin-bottom: 0')
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('card-generic-offer-details-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('card-generic-placeholder__animation'),
											A2($elm$html$Html$Attributes$attribute, 'style', 'height: 20px; margin-bottom: 0')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('card-generic-placeholder__background-masker'),
													A2($elm$html$Html$Attributes$attribute, 'style', 'left: 30%; right: 20%; height: 20px')
												]),
											_List_Nil)
										]))
								]))
						]))
				]))
		]));
var $author$project$AutomaticTranslations$clickToRetry = 'Volver a cargar';
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Carwow$StockDealCard$View$RetriableCard$view = function (retryMsg) {
	return A2(
		$elm$html$Html$article,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('card-generic card-generic__placeholder')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('card-generic__media-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('card-generic__media card-generic__media--centered card-generic__media--retry'),
								$elm$html$Html$Events$onClick(retryMsg),
								A2($elm$html$Html$Attributes$attribute, 'data-interaction-category', 'Showroom Index'),
								A2($elm$html$Html$Attributes$attribute, 'data-interaction-element', 'Retry card')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text($author$project$AutomaticTranslations$clickToRetry)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('card-generic__body')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('card-generic__section')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('card-generic__heading')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('card-generic-placeholder__field'),
												A2($elm$html$Html$Attributes$attribute, 'style', 'height: 20px; margin-bottom: 4px')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('card-generic-placeholder__background-masker'),
														A2($elm$html$Html$Attributes$attribute, 'style', 'left: 30%; right: 0; height: 20px')
													]),
												_List_Nil)
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('card-generic__title')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('card-generic-placeholder__field'),
												A2($elm$html$Html$Attributes$attribute, 'style', 'height: 20px; margin-bottom: 0')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('card-generic-placeholder__background-masker'),
														A2($elm$html$Html$Attributes$attribute, 'style', 'left: 50%; right: 0; height: 20px')
													]),
												_List_Nil)
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('card-generic__features')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('card-generic-placeholder__field'),
												A2($elm$html$Html$Attributes$attribute, 'style', 'height: 20px; margin-bottom: 0')
											]),
										_List_Nil)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('card-generic-offer-details-container')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('card-generic-placeholder__field'),
												A2($elm$html$Html$Attributes$attribute, 'style', 'height: 20px; margin-bottom: 0')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('card-generic-placeholder__background-masker'),
														A2($elm$html$Html$Attributes$attribute, 'style', 'left: 30%; right: 20%; height: 20px')
													]),
												_List_Nil)
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Carwow$StockDealCard$view = function (model) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id(model._)
			]),
		function () {
			var _v0 = model.u;
			switch (_v0.$) {
				case 2:
					var deal = _v0.a;
					return _List_fromArray(
						[
							$author$project$Carwow$StockDealCard$View$DealCard$view(
							A2($author$project$Carwow$StockDealCard$ViewModel$mapDeal, model.ba, deal))
						]);
				case 3:
					return _List_fromArray(
						[
							$author$project$Carwow$StockDealCard$View$RetriableCard$view($author$project$Carwow$StockDealCard$RetryRequested)
						]);
				default:
					return _List_fromArray(
						[$author$project$Carwow$StockDealCard$View$PlaceholderCard$view]);
			}
		}());
};
var $author$project$Carwow$StockDealCard$main = $elm$browser$Browser$element(
	{c6: $author$project$Carwow$StockDealCard$init, dK: $author$project$Carwow$StockDealCard$subscriptions, dY: $author$project$Carwow$StockDealCard$update, d0: $author$project$Carwow$StockDealCard$view});
_Platform_export({'Carwow':{'StockDealCard':{'init':$author$project$Carwow$StockDealCard$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (userLocation) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (sourcePartner) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (showPriceConfidence) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (showPowerKw) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (showEfficiencyDetails) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (showAskForLeasingPrice) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (jwt) {
															return A2(
																$elm$json$Json$Decode$andThen,
																function (hideDistance) {
																	return A2(
																		$elm$json$Json$Decode$andThen,
																		function (dealsServiceApiEndpoint) {
																			return A2(
																				$elm$json$Json$Decode$andThen,
																				function (dealPath) {
																					return A2(
																						$elm$json$Json$Decode$andThen,
																						function (dealId) {
																							return A2(
																								$elm$json$Json$Decode$andThen,
																								function (dataAttributes) {
																									return A2(
																										$elm$json$Json$Decode$andThen,
																										function (badge) {
																											return A2(
																												$elm$json$Json$Decode$andThen,
																												function (appName) {
																													return $elm$json$Json$Decode$succeed(
																														{az: appName, Y: badge, ab: dataAttributes, ac: dealId, ad: dealPath, N: dealsServiceApiEndpoint, af: hideDistance, aP: jwt, ao: showAskForLeasingPrice, ap: showEfficiencyDetails, aq: showPowerKw, ar: showPriceConfidence, as: sourcePartner, aw: userLocation});
																												},
																												A2(
																													$elm$json$Json$Decode$field,
																													'appName',
																													$elm$json$Json$Decode$oneOf(
																														_List_fromArray(
																															[
																																$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																																A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																															]))));
																										},
																										A2(
																											$elm$json$Json$Decode$field,
																											'badge',
																											$elm$json$Json$Decode$oneOf(
																												_List_fromArray(
																													[
																														$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																														A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																													]))));
																								},
																								A2(
																									$elm$json$Json$Decode$field,
																									'dataAttributes',
																									$elm$json$Json$Decode$list(
																										A2(
																											$elm$json$Json$Decode$andThen,
																											function (value) {
																												return A2(
																													$elm$json$Json$Decode$andThen,
																													function (name) {
																														return $elm$json$Json$Decode$succeed(
																															{di: name, d_: value});
																													},
																													A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string));
																											},
																											A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$string)))));
																						},
																						A2($elm$json$Json$Decode$field, 'dealId', $elm$json$Json$Decode$string));
																				},
																				A2($elm$json$Json$Decode$field, 'dealPath', $elm$json$Json$Decode$string));
																		},
																		A2($elm$json$Json$Decode$field, 'dealsServiceApiEndpoint', $elm$json$Json$Decode$string));
																},
																A2($elm$json$Json$Decode$field, 'hideDistance', $elm$json$Json$Decode$bool));
														},
														A2($elm$json$Json$Decode$field, 'jwt', $elm$json$Json$Decode$string));
												},
												A2($elm$json$Json$Decode$field, 'showAskForLeasingPrice', $elm$json$Json$Decode$string));
										},
										A2($elm$json$Json$Decode$field, 'showEfficiencyDetails', $elm$json$Json$Decode$string));
								},
								A2($elm$json$Json$Decode$field, 'showPowerKw', $elm$json$Json$Decode$string));
						},
						A2($elm$json$Json$Decode$field, 'showPriceConfidence', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'sourcePartner', $elm$json$Json$Decode$string));
		},
		A2(
			$elm$json$Json$Decode$field,
			'userLocation',
			A2(
				$elm$json$Json$Decode$andThen,
				function (_v0) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (_v1) {
							return $elm$json$Json$Decode$succeed(
								_Utils_Tuple2(_v0, _v1));
						},
						A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$float));
				},
				A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$float)))))(0)}}});}(this));